import { Flashcard } from './flashcards';

// New Jersey: 100 NJ-specific + 400 National, 0 duplicates removed = 500 total

export const flashcards: Flashcard[] = [
  {
    id: 1,
    question: "How many hours of prelicensure education are currently required for a New Jersey real estate salesperson license?",
    answer: "75 hours of approved prelicensure education.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "New Jersey currently requires a 75-hour prelicensure salesperson course before a candidate may qualify for the licensing exam."
  },
  {
    id: 2,
    question: "What are two key qualifications for an initial New Jersey real estate salesperson license besides education and passing the exam?",
    answer: "The applicant must be at least 18 years old, have a high school diploma or equivalent, and apply through a sponsoring employing broker.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "New Jersey requires minimum age, basic education, and broker sponsorship before a salesperson can be licensed and begin practice."
  },
  {
    id: 3,
    question: "How long is the term of a New Jersey real estate license?",
    answer: "Two years.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "New Jersey real estate licenses are issued on a two-year license cycle."
  },
  {
    id: 4,
    question: "After passing the New Jersey salesperson exam, through whom must the applicant apply for licensure?",
    answer: "Through a sponsoring employing broker.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "A New Jersey salesperson does not practice independently and must be hired through an employing broker."
  },
  {
    id: 5,
    question: "How many continuing education credit hours are generally required for a New Jersey broker or salesperson to renew a license during a normal license term?",
    answer: "12 continuing education credit hours.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "New Jersey generally requires 12 CE credits per license term, with at least 6 credits in core topics."
  },
  {
    id: 6,
    question: "Within the New Jersey continuing education requirement, how many ethics credit hours are currently mandatory?",
    answer: "At least 2 ethics credit hours.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "New Jersey's core CE requirements currently include at least 2 credits in ethics, plus separate required credits in agency and Fair Housing/NJLAD."
  },
  {
    id: 7,
    question: "What New Jersey law is especially important in state fair housing questions in addition to federal fair housing law?",
    answer: "The New Jersey Law Against Discrimination (NJLAD).",
    category: "NJ Agency and Fair Housing",
    difficulty: "easy",
    explanation: "New Jersey fair housing questions often involve both federal law and NJLAD, which is central to anti-discrimination compliance in the state."
  },
  {
    id: 8,
    question: "A New Jersey licensee refusing to show housing to a family because the family has children would most directly create what issue?",
    answer: "A fair housing violation involving familial-status discrimination.",
    category: "NJ Agency and Fair Housing",
    difficulty: "easy",
    explanation: "Familial status is a protected fair housing concept, so excluding families with children is a high-risk discriminatory act."
  },
  {
    id: 9,
    question: "What is the main purpose of New Jersey's Consumer Information Statement?",
    answer: "To explain the brokerage business relationship options and related duties before substantive real estate services are provided.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New Jersey agency and business-relationship questions often center on the Consumer Information Statement and how it informs consumers about representation choices."
  },
  {
    id: 10,
    question: "In New Jersey, what is designated agency?",
    answer: "A business relationship in which a brokerage designates separate licensees within the same firm to represent different principals, subject to the governing legal requirements.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Recent New Jersey law changes elevated designated agency as a tested business-relationship concept distinct from ordinary single agency."
  },
  {
    id: 11,
    question: "What should a New Jersey licensee avoid when answering questions that could steer a consumer toward or away from a neighborhood based on protected-class considerations?",
    answer: "Steering or discriminatory guidance.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Fair housing compliance includes avoiding advice or conduct that channels consumers based on protected-class implications."
  },
  {
    id: 12,
    question: "When accepting a listing of property for sale or rental in New Jersey, what anti-discrimination document are licensees required to provide to the property owner?",
    answer: "The required Letter to Property Owners concerning housing discrimination laws.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New Jersey expressly requires delivery of a housing-discrimination letter to property owners when a listing is accepted."
  },
  {
    id: 13,
    question: "May an unlicensed assistant in New Jersey negotiate price or contract terms with buyers or sellers?",
    answer: "No. Negotiating real estate terms is licensed activity.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "New Jersey distinguishes clerical support from licensed brokerage activity, and negotiation falls on the licensed side of that line."
  },
  {
    id: 14,
    question: "A New Jersey brokerage's written procedures for escrow monies and financial recordkeeping are primarily intended to support what?",
    answer: "Compliance, supervision, and proper handling of client funds.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Escrow and recordkeeping are core New Jersey supervision topics and are emphasized in both CE and brokerage compliance materials."
  },
  {
    id: 15,
    question: "In New Jersey real estate practice, attorney review is most closely associated with what part of a transaction?",
    answer: "The legal review period following contract formation in many residential transactions.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Attorney review is a widely tested New Jersey transaction concept and a notable feature of residential contract practice in the state."
  },
  {
    id: 16,
    question: "If a New Jersey seller knows of a material property problem and hides it instead of disclosing it, what issue is most directly raised?",
    answer: "A disclosure and concealment problem involving a material defect.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "State exam questions frequently test concealment of known material defects as a transaction and consumer-protection problem."
  },
  {
    id: 17,
    question: "Which New Jersey local body is most commonly associated with subdivision and development review?",
    answer: "The planning board.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Planning boards are commonly connected with subdivision and development matters, while zoning boards more often handle variance-type relief."
  },
  {
    id: 18,
    question: "Which New Jersey local body is most commonly associated with requests for relief from zoning restrictions?",
    answer: "The zoning board of adjustment or zoning board handling variances.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "New Jersey land-use questions often distinguish planning-board functions from zoning-board variance functions."
  },
  {
    id: 19,
    question: "If a New Jersey property's effective gross income is $140,000 and operating expenses are $50,000, what is the NOI?",
    answer: "$90,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Net operating income equals effective gross income minus operating expenses. $140,000 - $50,000 = $90,000."
  },
  {
    id: 20,
    question: "If a New Jersey property has NOI of $84,000 and a capitalization rate of 7%, what is the indicated value?",
    answer: "$1,200,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by cap rate. $84,000 / 0.07 = $1,200,000."
  },
  {
    id: 21,
    question: "What is the main function of New Jersey's Real Estate Commission?",
    answer: "To regulate the licensing and conduct of real estate brokers, salespersons, and related real estate activities in the state.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "The New Jersey Real Estate Commission is the state's primary licensing and regulatory authority for real estate practice."
  },
  {
    id: 22,
    question: "A New Jersey salesperson may lawfully conduct brokerage activities only under whose authority?",
    answer: "An employing broker's authority.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "A salesperson in New Jersey acts through the employing broker and does not practice independently."
  },
  {
    id: 23,
    question: "What is the practical purpose of New Jersey's mandatory continuing education requirement?",
    answer: "To keep licensees current on core legal, agency, ethics, and fair housing obligations affecting real estate practice.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "New Jersey CE requirements are designed to reinforce current legal and professional standards rather than serve as a one-time licensing hurdle."
  },
  {
    id: 24,
    question: "A New Jersey broker who fails to supervise trust account handling most directly risks what kind of issue?",
    answer: "A licensing and disciplinary compliance issue.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Trust-account supervision is a core broker responsibility and a common basis for regulatory discipline."
  },
  {
    id: 25,
    question: "What is the main purpose of New Jersey's anti-discrimination Letter to Property Owners?",
    answer: "To inform owners that housing discrimination is illegal and that listings must be handled in compliance with fair housing laws.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "The letter reinforces that property owners cannot direct licensees to market or refuse housing in a discriminatory way."
  },
  {
    id: 26,
    question: "A New Jersey landlord who tells a broker not to rent to people of a certain national origin is creating what kind of issue?",
    answer: "A fair housing discrimination issue.",
    category: "NJ Agency and Fair Housing",
    difficulty: "easy",
    explanation: "National origin is a protected category, so discriminatory instructions from a landlord cannot be followed lawfully."
  },
  {
    id: 27,
    question: "Why is New Jersey's Consumer Information Statement important before substantive brokerage services are provided?",
    answer: "It helps consumers understand the business relationship options before relying on the licensee for representation or service.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "The statement is intended to promote informed consent and clarity about how the brokerage will interact with the consumer."
  },
  {
    id: 28,
    question: "A New Jersey brokerage acting through designated agents within the same firm is still primarily dealing with what exam concept?",
    answer: "The brokerage business relationship and agency structure.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Designated agency is tested as a nuanced business-relationship structure rather than simple single agency."
  },
  {
    id: 29,
    question: "In New Jersey residential practice, what is attorney review most likely to affect?",
    answer: "Whether the signed contract proceeds unchanged, is disapproved, or is modified during the review period.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "Attorney review is a major New Jersey transaction concept because it can alter the practical finality of a signed residential contract."
  },
  {
    id: 30,
    question: "Why is proper escrow recordkeeping especially important in New Jersey brokerage practice?",
    answer: "Because it documents the lawful handling of client funds and supports compliance review by regulators and the broker.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Escrow compliance is a core transaction-practice area and poor records can create significant disciplinary exposure."
  },
  {
    id: 31,
    question: "A New Jersey licensee who misstates a material fact about a property's condition most directly creates what kind of problem?",
    answer: "A transaction misrepresentation and disclosure problem.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Misstating important condition facts can affect the consumer's decision and is a common tested transaction-law issue."
  },
  {
    id: 32,
    question: "What is the main practical reason New Jersey exam takers should understand attorney review?",
    answer: "Because it is a distinctive New Jersey transaction feature that affects contract handling and timing in residential sales.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Attorney review is one of the most recognizable NJ-specific transaction concepts and is frequently emphasized in prep materials."
  },
  {
    id: 33,
    question: "What type of New Jersey ownership form is most associated with a condominium purchase?",
    answer: "Ownership of an individual unit together with an undivided interest in the common elements.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "A condominium owner usually receives unit ownership plus a share of the common elements, unlike a cooperative shareholder."
  },
  {
    id: 34,
    question: "What type of New Jersey ownership form is most associated with a cooperative housing purchase?",
    answer: "Ownership of shares in a corporation plus a proprietary lease.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Cooperative ownership is commonly tested against condominium ownership because the legal structure is very different."
  },
  {
    id: 35,
    question: "Why do New Jersey buyers care about zoning and land-use approvals?",
    answer: "Because they can affect whether the property may be used, improved, or developed as the buyer intends.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Land-use questions often come down to whether the intended use is legally permitted."
  },
  {
    id: 36,
    question: "If a New Jersey buyer borrows $340,000 at 85% loan-to-value, what is the approximate value or purchase price?",
    answer: "$400,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals loan amount divided by LTV. $340,000 / 0.85 = $400,000."
  },
  {
    id: 37,
    question: "If a New Jersey property is assessed at $280,000 and the tax rate is 2.25%, what is the annual property tax?",
    answer: "$6,300.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Annual property tax equals assessed value multiplied by the tax rate. $280,000 x 0.0225 = $6,300."
  },
  {
    id: 38,
    question: "What appraisal approach is usually most relevant to a typical owner-occupied New Jersey one-family home?",
    answer: "The sales comparison approach.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "A typical one-family owner-occupied home is usually valued most directly by comparing it to similar recent sales."
  },
  {
    id: 39,
    question: "What is the main reason New Jersey exam takers should understand net operating income?",
    answer: "Because it is a core income-property concept used in investment analysis and value estimation.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "NOI is central to commercial and investment analysis, especially when paired with capitalization rate questions."
  },
  {
    id: 40,
    question: "If a New Jersey property generates $180,000 in effective gross income and has $72,000 in operating expenses, what is the NOI?",
    answer: "$108,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Net operating income equals effective gross income minus operating expenses. $180,000 - $72,000 = $108,000."
  },
  {
    id: 41,
    question: "What is the practical difference between a New Jersey condominium and a cooperative from an ownership standpoint?",
    answer: "A condominium owner owns real property in the unit, while a cooperative occupant typically owns shares in a corporation and a proprietary lease.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This is a classic ownership comparison question and a frequent exam distinction."
  },
  {
    id: 42,
    question: "Why is zoning important to a New Jersey buyer planning to use property for a special purpose?",
    answer: "Because zoning rules may prohibit or limit that intended use even if the buyer wants to proceed.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Land-use control questions often turn on whether the buyer's intended use is legally allowed."
  },
  {
    id: 43,
    question: "What is the main reason a New Jersey buyer should care whether a property is subject to a variance or zoning relief issue?",
    answer: "Because the property's permitted use or improvement rights may depend on local land-use approval.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Variance-related questions are important because they directly affect use and development potential."
  },
  {
    id: 44,
    question: "In New Jersey, why might a planning board matter more to a developer than to a typical homebuyer?",
    answer: "Because planning boards are more directly involved in subdivision, development, and related land-use approvals.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Planning boards are central to site planning and subdivision activity, which makes them especially relevant to development questions."
  },
  {
    id: 45,
    question: "What is the main role of a New Jersey zoning board when a property owner cannot comply with current zoning restrictions?",
    answer: "To hear requests for zoning relief such as variances under applicable local land-use rules.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Zoning boards are commonly tested as the body connected to requests for relief from zoning requirements."
  },
  {
    id: 46,
    question: "Why is title important in a New Jersey real estate transaction?",
    answer: "Because the buyer wants to receive ownership free from unacceptable defects, claims, or encumbrances.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Title issues affect whether ownership can be transferred in a form the buyer and lender will accept."
  },
  {
    id: 47,
    question: "If a New Jersey property's annual property taxes are $9,600, what is the monthly equivalent for budgeting purposes?",
    answer: "$800 per month.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Monthly cost equals annual amount divided by 12. $9,600 / 12 = $800."
  },
  {
    id: 48,
    question: "If a New Jersey buyer makes a 20% down payment on a $500,000 property, what is the loan amount?",
    answer: "$400,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "A 20 percent down payment on $500,000 is $100,000, leaving a loan amount of $400,000."
  },
  {
    id: 49,
    question: "An investor sees New Jersey property NOI of $96,000 and a capitalization rate of 8%. What value is indicated?",
    answer: "$1,200,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by cap rate. $96,000 / 0.08 = $1,200,000."
  },
  {
    id: 50,
    question: "What is the main purpose of a comparative market analysis in New Jersey residential practice?",
    answer: "To help estimate a property's likely market price by comparing it with similar recent sales.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "A CMA is a pricing tool based on market comparison, not a formal appraisal."
  },
  {
    id: 51,
    question: "A New Jersey tax bill is based on an assessed value of $350,000 and a 2% tax rate. What annual tax results?",
    answer: "$7,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Annual tax equals assessed value multiplied by the tax rate. $350,000 x 0.02 = $7,000."
  },
  {
    id: 52,
    question: "What is the main reason a New Jersey broker must supervise escrow deposits carefully?",
    answer: "Because mishandling client funds can create serious regulatory, disciplinary, and trust-account compliance problems.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Escrow handling is one of the most sensitive areas of brokerage compliance."
  },
  {
    id: 53,
    question: "Why is it important for a New Jersey brokerage to maintain complete transaction files?",
    answer: "Because the files help prove what agreements, disclosures, and fund-handling actions actually occurred.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Good transaction files support both compliance and defensibility if a dispute arises."
  },
  {
    id: 54,
    question: "What is the practical effect of a material misrepresentation by a New Jersey licensee?",
    answer: "It can mislead a consumer in a significant way and create legal and disciplinary exposure.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Material misrepresentation is a serious transaction-practice issue because it affects consumer decision-making."
  },
  {
    id: 55,
    question: "Why is New Jersey's attorney review concept especially important for exam prep?",
    answer: "Because it is a distinctive state-specific transaction rule that can change the status of a residential contract after signing.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Attorney review is a signature New Jersey transaction concept and commonly appears on state exam prep."
  },
  {
    id: 56,
    question: "Why does New Jersey require a salesperson to work through a sponsoring broker?",
    answer: "To ensure the salesperson practices under supervision rather than independently.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "New Jersey licensing structure places responsibility and oversight with the employing broker."
  },
  {
    id: 57,
    question: "Why does New Jersey require both ethics and fair housing or agency-related continuing education?",
    answer: "To reinforce compliance in high-risk practice areas that directly affect consumers and brokerage conduct.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "The CE structure is designed to emphasize legal and professional topics that are especially important in day-to-day practice."
  },
  {
    id: 58,
    question: "What is the main risk if a New Jersey licensee follows a property owner's discriminatory instruction?",
    answer: "The licensee can participate in a fair housing violation.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "A client instruction does not excuse unlawful discrimination."
  },
  {
    id: 59,
    question: "Why is the Consumer Information Statement important to a New Jersey consumer before relying on a licensee?",
    answer: "Because it explains the business relationship options and helps the consumer understand the role the brokerage will play.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "The statement is meant to create informed understanding before substantive brokerage service begins."
  },
  {
    id: 60,
    question: "What is the main fair housing danger when a New Jersey licensee discusses where certain 'types' of people should live?",
    answer: "It can amount to unlawful steering.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Steering is a classic fair housing issue because it channels housing choice based on protected-class implications."
  },
  {
    id: 61,
    question: "What is the practical reason New Jersey requires a salesperson to be hired through an employing broker?",
    answer: "To place responsibility for supervision, compliance, and brokerage operations with the broker rather than the salesperson acting alone.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "This reflects the state's licensing structure, in which the broker is the responsible supervising licensee."
  },
  {
    id: 62,
    question: "Why are core continuing education topics such as agency, ethics, and fair housing especially important in New Jersey?",
    answer: "Because they cover high-risk legal duties that directly affect consumers and are central to lawful brokerage practice.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "The state emphasizes those topics because they are among the most important sources of compliance risk."
  },
  {
    id: 63,
    question: "A New Jersey broker's duty to supervise advertising, escrow handling, and transaction records is mainly part of what concept?",
    answer: "Broker professional responsibility and supervision.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "State licensing law places operational oversight duties on the broker as the supervising licensee."
  },
  {
    id: 64,
    question: "What is the practical risk if a New Jersey salesperson performs licensed activity before the required licensing process is properly completed?",
    answer: "Licensing violations and possible discipline.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Practicing without proper authority is a direct licensing problem, not just a paperwork issue."
  },
  {
    id: 65,
    question: "Why should a New Jersey licensee be cautious about describing a neighborhood in a way tied to protected classes?",
    answer: "Because those statements can create fair housing problems even if framed as informal advice.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Fair housing violations can arise from guidance that channels or discourages consumers based on protected-class implications."
  },
  {
    id: 66,
    question: "Why does New Jersey require anti-discrimination notices for owners and consumers in real estate transactions?",
    answer: "To make clear that housing transactions must be conducted without unlawful discrimination.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "These requirements reinforce that fair housing compliance is an active obligation in the transaction."
  },
  {
    id: 67,
    question: "Why is designated agency in New Jersey a frequently tested topic?",
    answer: "Because it is a specific business-relationship structure that students often confuse with ordinary single agency or full dual agency.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Exam questions often test whether the student understands the legal relationship created by designated agents in the same firm."
  },
  {
    id: 68,
    question: "A New Jersey buyer wants to know whether the brokerage is representing the buyer, the seller, or acting in another approved business relationship. What document is designed to help with that understanding?",
    answer: "The Consumer Information Statement.",
    category: "NJ Agency and Fair Housing",
    difficulty: "easy",
    explanation: "The Consumer Information Statement is specifically aimed at explaining brokerage relationship choices."
  },
  {
    id: 69,
    question: "Why is accurate handling of material property-condition information important in New Jersey transactions?",
    answer: "Because consumers may rely on it when deciding whether and on what terms to proceed.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Misstatements or concealment can alter consumer decisions and create serious legal exposure."
  },
  {
    id: 70,
    question: "What is the practical reason New Jersey brokers maintain trust-account and transaction records in an organized way?",
    answer: "To show that money and documents were handled properly if the transaction or brokerage is reviewed later.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Proper records are critical evidence of compliance and transaction handling."
  },
  {
    id: 71,
    question: "Why does New Jersey exam prep place so much emphasis on attorney review in residential sales?",
    answer: "Because it is a distinctive state-specific contract process that affects timing, negotiation, and contract status after signing.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Attorney review is one of the most recognizable differences between New Jersey residential practice and many other states."
  },
  {
    id: 72,
    question: "A New Jersey licensee who mishandles an earnest money deposit most directly creates what kind of issue?",
    answer: "A trust-fund and transaction-compliance issue.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Earnest money handling is a core compliance area because the funds belong to others and must be managed properly."
  },
  {
    id: 73,
    question: "Why does ownership structure matter to a New Jersey buyer comparing a condo and a co-op?",
    answer: "Because the legal form of ownership affects the buyer's rights, obligations, and how the interest is held.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "The exam often tests the basic legal distinction between ownership of real property and ownership through shares plus a proprietary lease."
  },
  {
    id: 74,
    question: "What is the practical importance of a variance issue to a New Jersey property owner?",
    answer: "It may determine whether the owner can lawfully use or improve the property as intended.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Variance questions matter because they can directly affect the property's actual usefulness."
  },
  {
    id: 75,
    question: "Why is title review important in a New Jersey sale even if the buyer likes the physical property itself?",
    answer: "Because the buyer also needs acceptable legal ownership, not just a desirable building or location.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Real estate value depends on both the physical property and the quality of the title being transferred."
  },
  {
    id: 76,
    question: "If a New Jersey property has effective gross income of $150,000 and operating expenses of $60,000, what is the NOI?",
    answer: "$90,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Net operating income equals effective gross income minus operating expenses. $150,000 - $60,000 = $90,000."
  },
  {
    id: 77,
    question: "If a New Jersey loan amount is $360,000 and the loan is 90% of value, what is the approximate value or purchase price?",
    answer: "$400,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals loan amount divided by loan-to-value ratio. $360,000 / 0.90 = $400,000."
  },
  {
    id: 78,
    question: "If a New Jersey property is assessed at $420,000 and taxed at 2.5%, what is the annual tax?",
    answer: "$10,500.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Annual property tax equals assessed value multiplied by the tax rate. $420,000 x 0.025 = $10,500."
  },
  {
    id: 79,
    question: "Why is the sales comparison approach so important for a typical New Jersey owner-occupied residential property?",
    answer: "Because similar recent sales usually provide the clearest market evidence of value for that type of property.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "For a typical residential home, comparable sales generally give the most direct indication of market value."
  },
  {
    id: 80,
    question: "Using a 10% cap rate, what value is indicated for a New Jersey property with $120,000 NOI?",
    answer: "$1,200,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by capitalization rate. $120,000 / 0.10 = $1,200,000."
  },
  {
    id: 81,
    question: "A New Jersey salesperson's authority to work in brokerage comes from what relationship?",
    answer: "The salesperson's association with an employing broker.",
    category: "NJ License Law and Professional Practice",
    difficulty: "easy",
    explanation: "A salesperson is licensed to act through the employing broker rather than as an independent practitioner."
  },
  {
    id: 82,
    question: "When New Jersey tests continuing education, what is the state usually trying to reinforce?",
    answer: "That licensees must stay current in key compliance areas such as agency, ethics, and fair housing.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Continuing education is meant to keep practicing licensees current in the areas most likely to affect lawful conduct."
  },
  {
    id: 83,
    question: "What is the most direct compliance risk when a New Jersey broker fails to monitor office practices involving advertising and money handling?",
    answer: "Regulatory discipline for inadequate supervision.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "The broker is expected to supervise activities that can create licensing and consumer-protection problems."
  },
  {
    id: 84,
    question: "Why does New Jersey require real estate practice to be tied to a licensed broker rather than left entirely to the salesperson?",
    answer: "Because the broker is the legally responsible party for supervision and the conduct of the brokerage business.",
    category: "NJ License Law and Professional Practice",
    difficulty: "medium",
    explanation: "The supervision model is fundamental to how New Jersey regulates brokerage activity."
  },
  {
    id: 85,
    question: "A New Jersey owner says a property should be marketed only to one type of buyer. What is the correct legal concern for the licensee?",
    answer: "The instruction may violate fair housing laws and cannot simply be followed.",
    category: "NJ Agency and Fair Housing",
    difficulty: "medium",
    explanation: "A client's discriminatory instruction does not excuse a licensee from fair housing compliance."
  },
  {
    id: 86,
    question: "A New Jersey consumer who receives the Consumer Information Statement is being informed primarily about what?",
    answer: "The possible brokerage business relationships and their meaning.",
    category: "NJ Agency and Fair Housing",
    difficulty: "easy",
    explanation: "The statement is meant to help the consumer understand how the brokerage may interact with the consumer in the transaction."
  },
  {
    id: 87,
    question: "Why is steering such a serious issue in New Jersey real estate practice?",
    answer: "Because it can limit housing choice based on protected-class considerations and violate fair housing law.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Steering undermines equal housing opportunity and is one of the clearest fair housing violations."
  },
  {
    id: 88,
    question: "What does designated agency in New Jersey try to address within one brokerage firm?",
    answer: "Representation of different principals through separate designated licensees under the firm's permitted agency structure.",
    category: "NJ Agency and Fair Housing",
    difficulty: "hard",
    explanation: "The concept is tested because students often confuse it with a simpler agency model."
  },
  {
    id: 89,
    question: "In a New Jersey residential sale, why can attorney review matter even after a contract is signed?",
    answer: "Because the contract may still be disapproved or revised during the attorney review period.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This is one of the distinctive transaction rules that makes New Jersey contract practice different from many states."
  },
  {
    id: 90,
    question: "What is the best reason for a New Jersey brokerage to document receipt and handling of deposits carefully?",
    answer: "To show that client funds were handled properly and in compliance with brokerage requirements.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Deposit handling is a core transaction-control issue and documentation supports compliance."
  },
  {
    id: 91,
    question: "If a New Jersey licensee gives a buyer inaccurate information about a material property issue, what is the most direct consequence conceptually?",
    answer: "The buyer may be misled on a material transaction fact.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "The key concept is that material misinformation can improperly affect the consumer's decision."
  },
  {
    id: 92,
    question: "Why does a New Jersey broker want complete records of disclosures and agreements in the file?",
    answer: "Because those records help establish what the brokerage actually did during the transaction.",
    category: "NJ Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Transaction files are a key compliance and defensibility tool."
  },
  {
    id: 93,
    question: "Which ownership issue is most important to understand when comparing a New Jersey condo to a co-op?",
    answer: "Whether the buyer is purchasing real property ownership or a share-based occupancy interest.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "That legal distinction drives many of the practical differences between the two forms."
  },
  {
    id: 94,
    question: "What is the most practical concern for a New Jersey buyer facing a zoning restriction?",
    answer: "Whether the desired use of the property is legally allowed.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Zoning questions almost always come back to whether the intended use is permitted."
  },
  {
    id: 95,
    question: "Why can local planning or zoning approvals influence a New Jersey property's value?",
    answer: "Because they can expand or limit how the property may be used or developed.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Use and development rights are major factors in real estate value."
  },
  {
    id: 96,
    question: "What is the practical purpose of title examination in a New Jersey sale?",
    answer: "To uncover ownership problems or encumbrances that could affect the transfer of acceptable title.",
    category: "NJ Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "The buyer and lender want confidence that the title can be transferred in acceptable condition."
  },
  {
    id: 97,
    question: "A New Jersey buyer purchases a property for $450,000 and makes a 20% down payment. What is the loan amount?",
    answer: "$360,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "A 20 percent down payment is $90,000, so the loan amount is $450,000 - $90,000 = $360,000."
  },
  {
    id: 98,
    question: "A New Jersey investor sees annual gross income of $200,000 and operating expenses of $80,000. What figure matters most before applying a capitalization rate?",
    answer: "Net operating income of $120,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "NOI is the key income figure used before applying a cap rate. $200,000 - $80,000 = $120,000."
  },
  {
    id: 99,
    question: "A New Jersey home's market value is most likely estimated primarily from what kind of evidence in a typical residential appraisal problem?",
    answer: "Comparable recent sales of similar properties.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "For typical owner-occupied housing, the strongest valuation evidence usually comes from comparable sales."
  },
  {
    id: 100,
    question: "A New Jersey property has NOI of $110,000 and a cap rate of 11%. What is the indicated value?",
    answer: "$1,000,000.",
    category: "NJ Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by capitalization rate. $110,000 / 0.11 = $1,000,000."
  },
  {
    id: 101,
    question: "What is real property?",
    answer: "Land, anything permanently attached to the land, and the bundle of legal rights that comes with ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Real property includes the physical land, improvements such as buildings, and legal interests like possession, control, enjoyment, exclusion, and disposition."
  },
  {
    id: 102,
    question: "What is the difference between real property and personal property?",
    answer: "Real property is immovable land and attached improvements, while personal property is movable and not permanently attached.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "The exam frequently tests whether an item is a fixture that became part of the real estate or remains personal property that can be removed."
  },
  {
    id: 103,
    question: "What is a fixture in real estate?",
    answer: "An item that was once personal property but became real property because it is attached or adapted to the land or building.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Fixture questions are commonly analyzed with tests such as method of attachment, adaptation, intent of the parties, relationship of the parties, and agreement."
  },
  {
    id: 104,
    question: "What does the bundle of rights include?",
    answer: "The rights of possession, control, enjoyment, exclusion, and disposition.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "These rights describe the legal benefits of ownership, though they can be limited by government powers, private restrictions, or liens."
  },
  {
    id: 105,
    question: "What is a fee simple estate?",
    answer: "The highest form of private ownership, with the greatest possible bundle of rights and potentially infinite duration.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Fee simple may be absolute or defeasible, but in either case it represents freehold ownership rather than a temporary leasehold interest."
  },
  {
    id: 106,
    question: "What is a life estate?",
    answer: "A freehold estate that lasts for the life of a named person and ends at that person's death.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "A life estate is not inheritable. When it ends, title passes to the remainderman or reverts to the original grantor, depending on how it was created."
  },
  {
    id: 107,
    question: "What is the difference between a freehold estate and a leasehold estate?",
    answer: "A freehold estate involves ownership for an uncertain duration, while a leasehold estate gives a tenant the right to possess property for a limited time.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Freehold estates include fee simple and life estates. Leasehold estates are nonfreehold interests such as estate for years, periodic tenancy, and tenancy at will."
  },
  {
    id: 108,
    question: "What is tenancy in common?",
    answer: "A form of co-ownership in which two or more people hold undivided interests that may be unequal and are inheritable.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Each tenant in common has the right to use the whole property, but there is no right of survivorship unless state law or the deed provides otherwise."
  },
  {
    id: 109,
    question: "What is joint tenancy?",
    answer: "A form of co-ownership in which co-owners hold equal undivided interests with a right of survivorship.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Joint tenancy typically requires the four unities of time, title, interest, and possession. When one owner dies, that interest passes to the surviving joint tenants."
  },
  {
    id: 110,
    question: "What is tenancy by the entirety?",
    answer: "A special form of ownership available only to married couples in many states, featuring survivorship and protection from the separate debts of one spouse in some jurisdictions.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This estate is tested as a marital ownership form. The exact creditor protections depend on state law, but nationally it is distinguished from ordinary joint tenancy."
  },
  {
    id: 111,
    question: "What is an easement appurtenant?",
    answer: "An easement that benefits one parcel of land and runs with that land, usually involving a dominant tenement and a servient tenement.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Because it attaches to the land rather than a specific person, an easement appurtenant generally transfers automatically when the benefited parcel is sold."
  },
  {
    id: 112,
    question: "What is an easement in gross?",
    answer: "An easement that benefits a person or company rather than a neighboring parcel of land.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Utility easements are a common example. Unlike an easement appurtenant, there is no dominant tenement because the benefit is personal or commercial."
  },
  {
    id: 113,
    question: "What is an encroachment?",
    answer: "An unauthorized physical intrusion of one person's improvement onto another person's land.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Examples include a fence, driveway, or structure crossing a boundary line. Encroachments are often discovered by a survey and can create title issues."
  },
  {
    id: 114,
    question: "What is a lien?",
    answer: "A charge against property that secures payment of a debt or performance of an obligation.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Liens can be voluntary, such as a mortgage, or involuntary, such as a property tax lien or judgment lien."
  },
  {
    id: 115,
    question: "Which lien generally has highest priority: a property tax lien or a mortgage lien?",
    answer: "A property tax lien generally has highest priority.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Ad valorem tax liens are typically superior to previously recorded private liens, making lien priority a frequent exam concept."
  },
  {
    id: 116,
    question: "What are the basic government powers over real estate?",
    answer: "Taxation, eminent domain, police power, and escheat.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "A common exam memory aid is PETE: Police power, Eminent domain, Taxation, and Escheat."
  },
  {
    id: 117,
    question: "What is eminent domain?",
    answer: "The government's power to take private property for public use, with payment of just compensation.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "The taking itself is eminent domain; the legal process used to carry it out is condemnation."
  },
  {
    id: 118,
    question: "What is police power in real estate?",
    answer: "The government's authority to regulate land use in order to protect public health, safety, morals, and general welfare.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Zoning, building codes, environmental regulations, and subdivision rules are classic examples of police power."
  },
  {
    id: 119,
    question: "What is a metes-and-bounds legal description?",
    answer: "A description that identifies a parcel by starting at a point of beginning and tracing its boundaries by directions and distances.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This method is commonly used for irregularly shaped parcels and must return to the point of beginning to fully describe the property."
  },
  {
    id: 120,
    question: "What is the rectangular survey system used to describe?",
    answer: "Land in many states using principal meridians, base lines, townships, ranges, and sections.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Also called the government survey system, it generally applies to land divided into 6-mile-square townships, each containing 36 one-mile-square sections."
  },
  {
    id: 121,
    question: "What is an express agency relationship in real estate?",
    answer: "An agency relationship created by an oral or written agreement between the principal and the agent.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "Listing agreements and buyer representation agreements are common examples of express agency because the relationship is intentionally created."
  },
  {
    id: 122,
    question: "What is implied agency?",
    answer: "An agency relationship inferred from the actions or conduct of the parties rather than from an explicit agreement.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "This is risky because a licensee may create agency duties unintentionally through words or behavior even without a signed agreement."
  },
  {
    id: 123,
    question: "Which fiduciary duties does an agent owe a client?",
    answer: "Loyalty, obedience, disclosure, confidentiality, reasonable care, and accounting.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "These duties are heavily tested nationally because agency law is one of the most important exam categories."
  },
  {
    id: 124,
    question: "What is a customer in a real estate transaction?",
    answer: "A party who is not represented as a client but is still owed honest and fair dealing.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "A customer does not receive full fiduciary representation, but the licensee still must avoid fraud, misrepresentation, and concealment of material facts."
  },
  {
    id: 125,
    question: "What is a bilateral contract?",
    answer: "A contract in which both parties exchange promises.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "Most real estate sales contracts are bilateral because the buyer promises to buy and the seller promises to sell."
  },
  {
    id: 126,
    question: "What are the basic elements required for a valid contract?",
    answer: "Competent parties, lawful objective, offer and acceptance, and consideration.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "National exams often test whether a contract is valid, void, voidable, or unenforceable based on missing elements."
  },
  {
    id: 127,
    question: "What is consideration in a real estate contract?",
    answer: "Something of value exchanged by the parties, such as a promise, money, or performance.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "Consideration does not have to be earnest money. Mutual promises alone can be sufficient consideration."
  },
  {
    id: 128,
    question: "What does the Statute of Frauds generally require for contracts involving the sale of real estate?",
    answer: "They must be in writing and signed by the party to be charged in order to be enforceable.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "This rule is central in real estate because agreements affecting title or long-term interests in land usually must be written."
  },
  {
    id: 129,
    question: "What is earnest money?",
    answer: "A buyer's good-faith deposit showing serious intent to complete the purchase.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "Earnest money helps support the offer and is usually credited at closing if the transaction is completed."
  },
  {
    id: 130,
    question: "What is a contingency in a real estate contract?",
    answer: "A condition that must be met for the contract to remain binding or proceed to closing.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Financing, appraisal, and inspection contingencies are common examples that protect parties from specified risks."
  },
  {
    id: 131,
    question: "What is a promissory note?",
    answer: "A borrower's written promise to repay a debt according to specified terms.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "The note creates the debt, while the mortgage or deed of trust secures that debt with the property."
  },
  {
    id: 132,
    question: "What is the difference between a mortgage and a promissory note?",
    answer: "The promissory note is the promise to repay, while the mortgage is the security instrument that pledges the property as collateral.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Students often confuse the debt instrument with the security instrument. The note and mortgage serve different legal functions."
  },
  {
    id: 133,
    question: "What is loan-to-value ratio (LTV)?",
    answer: "The loan amount divided by the value or purchase price of the property, expressed as a percentage.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "LTV helps lenders measure risk because a higher LTV means the borrower has less equity invested."
  },
  {
    id: 134,
    question: "What is amortization?",
    answer: "The repayment of a loan over time through periodic installments of principal and interest.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "With full amortization, the loan balance is reduced to zero by the end of the loan term."
  },
  {
    id: 135,
    question: "What is private mortgage insurance (PMI)?",
    answer: "Insurance that protects the lender against borrower default, commonly required on certain high-LTV conventional loans.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "PMI protects the lender, not the borrower. It is often associated with loans where the down payment is less than 20 percent."
  },
  {
    id: 136,
    question: "What is a material fact in a real estate transaction?",
    answer: "A fact that could affect a reasonable person's decision regarding the property or transaction.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Licensees generally must disclose known material facts, especially those that affect value, desirability, or safety."
  },
  {
    id: 137,
    question: "What is the federal Fair Housing Act designed to prohibit?",
    answer: "Discrimination in housing-related activities based on protected characteristics.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "The national exam regularly tests fair housing because it applies broadly to real estate practice across states."
  },
  {
    id: 138,
    question: "What is steering in fair housing law?",
    answer: "Guiding buyers or renters toward or away from certain areas based on protected characteristics.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Steering is illegal because it limits housing choice based on discriminatory criteria."
  },
  {
    id: 139,
    question: "What is a deed?",
    answer: "A written instrument used to transfer title or an interest in real property from grantor to grantee.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "The deed transfers ownership, while the sales contract creates the parties' agreement to complete the transfer."
  },
  {
    id: 140,
    question: "What is title insurance?",
    answer: "Insurance that protects against certain losses from defects in title that existed before the policy was issued.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Title insurance differs from hazard insurance because it covers ownership defects and encumbrance issues, not future property damage."
  },
  {
    id: 141,
    question: "What is the sales comparison approach to value?",
    answer: "An appraisal approach that estimates value by comparing the subject property to recently sold similar properties and adjusting for differences.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "This is usually the most applicable approach for owner-occupied residential property because buyers and sellers rely heavily on comparable sales."
  },
  {
    id: 142,
    question: "What is the cost approach to value?",
    answer: "An appraisal approach based on the cost to replace or reproduce the improvements, minus depreciation, plus land value.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "The cost approach is often most useful for newer properties and special-purpose properties with limited comparable sales."
  },
  {
    id: 143,
    question: "What is the income approach to value?",
    answer: "An appraisal approach that estimates value based on the income a property can produce.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "This approach is especially important for investment and commercial property where value is tied to earning power."
  },
  {
    id: 144,
    question: "What is depreciation in appraisal?",
    answer: "A loss in value from any cause, including physical deterioration, functional obsolescence, or external obsolescence.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "In appraisal, depreciation is broader than tax depreciation. It refers to any reduction in value."
  },
  {
    id: 145,
    question: "What is functional obsolescence?",
    answer: "A loss in value caused by defects in design, layout, or utility within the property.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Examples include an outdated floor plan or inadequate parking. It differs from external obsolescence, which comes from outside the property."
  },
  {
    id: 146,
    question: "What is external obsolescence?",
    answer: "A loss in value caused by negative influences outside the property boundaries.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Nearby nuisances, adverse zoning changes, or neighborhood decline are common examples."
  },
  {
    id: 147,
    question: "What is a closing or settlement statement?",
    answer: "A document that itemizes the financial debits, credits, and amounts due from or to the parties at closing.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "This document shows how the final money figures in the transaction were calculated."
  },
  {
    id: 148,
    question: "What is prorating at closing?",
    answer: "Allocating expenses or income between buyer and seller according to the date of closing and each party's period of ownership or use.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Taxes, rents, interest, and association charges are common items that may be prorated."
  },
  {
    id: 149,
    question: "What is RESPA primarily designed to regulate?",
    answer: "Residential settlement practices, required disclosures, and the prohibition of certain kickbacks and referral fees in covered mortgage transactions.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "RESPA is a core national exam topic because it governs important parts of the closing process."
  },
  {
    id: 150,
    question: "What is TILA primarily designed to require?",
    answer: "Truthful disclosure of the cost of consumer credit so borrowers can compare loan terms.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "TILA focuses on credit cost disclosure, while RESPA focuses more on settlement practices and related disclosures."
  },
  {
    id: 151,
    question: "What is an FHA-insured loan?",
    answer: "A loan made by an approved lender and insured by the Federal Housing Administration against borrower default.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "The FHA does not usually lend the money directly. Instead, it insures approved loans that meet program standards."
  },
  {
    id: 152,
    question: "What is a VA-guaranteed loan?",
    answer: "A loan made by an approved lender and guaranteed by the Department of Veterans Affairs for eligible borrowers.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "Like FHA loans, VA loans are generally originated by lenders, while the federal government provides the guarantee rather than directly funding most loans."
  },
  {
    id: 153,
    question: "What is a conventional loan?",
    answer: "A loan that is not insured or guaranteed by a government agency such as FHA or VA.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "Conventional loans may be conforming or nonconforming depending on whether they meet secondary market standards."
  },
  {
    id: 154,
    question: "What is an adjustable-rate mortgage (ARM)?",
    answer: "A mortgage with an interest rate that can change over time based on the terms of the loan.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "ARMs are tested because payment amounts can change after the initial fixed-rate period, increasing borrower risk."
  },
  {
    id: 155,
    question: "What is an estate for years?",
    answer: "A leasehold estate with a definite beginning date and a definite ending date.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Despite the name, it can be for any fixed time period, even days or months, as long as the end date is certain."
  },
  {
    id: 156,
    question: "What is a periodic tenancy?",
    answer: "A leasehold that automatically renews for successive periods until proper notice is given.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Month-to-month tenancy is a common example. It continues until terminated according to law or the lease terms."
  },
  {
    id: 157,
    question: "What is a gross lease?",
    answer: "A lease in which the tenant pays a fixed rent and the landlord pays most or all of the operating expenses.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This is often contrasted with a net lease, where the tenant pays some or all of the property's operating costs."
  },
  {
    id: 158,
    question: "What is a net lease?",
    answer: "A lease in which the tenant pays rent plus some or all operating expenses of the property.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Net leases are common in commercial real estate because they shift some cost burden from landlord to tenant."
  },
  {
    id: 159,
    question: "What is the federal lead-based paint disclosure requirement generally associated with?",
    answer: "Many residential properties built before 1978.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "This is a major federal disclosure topic because older housing stock may contain lead-based paint hazards."
  },
  {
    id: 160,
    question: "Which protected classes are covered under the federal Fair Housing Act?",
    answer: "Race, color, religion, sex, national origin, familial status, and disability.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This list is heavily tested nationally. Some states add more protected classes, but these are the core federal categories."
  },
  {
    id: 161,
    question: "What is a general warranty deed?",
    answer: "A deed in which the grantor gives broad covenants of title and warrants against defects arising both before and during the grantor's ownership.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This deed gives the grantee the greatest protection because the grantor warrants the title against a broad range of defects."
  },
  {
    id: 162,
    question: "What is a special warranty deed?",
    answer: "A deed in which the grantor warrants title only against defects arising during the grantor's period of ownership.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "The grantor does not make promises about defects that may have existed before the grantor acquired title."
  },
  {
    id: 163,
    question: "What is a quitclaim deed?",
    answer: "A deed that conveys whatever interest the grantor may have, if any, without warranties of title.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Quitclaim deeds are often used to clear clouds on title or transfer possible interests without guaranteeing ownership."
  },
  {
    id: 164,
    question: "What is actual notice in real estate?",
    answer: "Direct knowledge of a fact, claim, or condition affecting property or a transaction.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Actual notice differs from constructive notice, which is knowledge the law presumes because information is in the public record."
  },
  {
    id: 165,
    question: "What is constructive notice in real estate?",
    answer: "Notice the public is presumed to have because information has been properly recorded in the public record.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Recording statutes rely on constructive notice to protect later buyers and lenders who search the public record."
  },
  {
    id: 166,
    question: "What is an acceleration clause in a mortgage?",
    answer: "A clause allowing the lender to declare the entire unpaid loan balance immediately due after borrower default.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Acceleration is an important default concept because it ends the borrower's right to continue making only installment payments."
  },
  {
    id: 167,
    question: "What is a due-on-sale clause?",
    answer: "A clause allowing the lender to demand full repayment if the property is transferred without the lender's consent.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "This clause helps lenders control changes in ownership that may affect loan risk or interest yield."
  },
  {
    id: 168,
    question: "What is a prepayment penalty?",
    answer: "A fee some lenders charge if the borrower pays off the loan before a specified time.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "The penalty compensates the lender for lost expected interest income when a loan is paid off early."
  },
  {
    id: 169,
    question: "What is a balloon payment?",
    answer: "A large lump-sum payment due at the end of a loan term after smaller regular payments have been made.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Balloon loans are risky for borrowers who may be unable to refinance or pay the final amount when due."
  },
  {
    id: 170,
    question: "What is assumed by a buyer who takes over an existing mortgage through assumption?",
    answer: "Responsibility for the mortgage debt, subject to lender approval and the terms of the transaction.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Assumption differs from taking title subject to a mortgage because assumption generally involves personal liability for the debt."
  },
  {
    id: 171,
    question: "What is dual agency?",
    answer: "An agency relationship in which one brokerage or agent represents both the buyer and the seller in the same transaction, subject to state law and required consent.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "Dual agency is heavily tested because it creates potential conflicts with undivided loyalty and full disclosure."
  },
  {
    id: 172,
    question: "What is a universal agent?",
    answer: "An agent authorized to act for a principal in a broad range of matters, often under a power of attorney.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "This contrasts with a special agent, such as a real estate broker, who is typically authorized for limited acts related to a specific transaction."
  },
  {
    id: 173,
    question: "What is a special agent in real estate?",
    answer: "An agent authorized to perform specific acts for a principal, usually related to a particular transaction.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "Real estate licensees are commonly treated as special agents because their authority is limited to tasks like finding a buyer or seller."
  },
  {
    id: 174,
    question: "If a property sells for $360,000 and the commission is 6%, what is the total commission?",
    answer: "$21,600.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Commission equals sale price multiplied by commission rate. Here, $360,000 x 0.06 = $21,600."
  },
  {
    id: 175,
    question: "If annual property taxes are $4,800, what is the monthly amount for tax escrow?",
    answer: "$400.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "To find the monthly escrow amount, divide the annual taxes by 12. Here, $4,800 / 12 = $400."
  },
  {
    id: 176,
    question: "If a lender loans $240,000 at 80% loan-to-value, what is the property's value or purchase price?",
    answer: "$300,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Value equals loan amount divided by LTV. Here, $240,000 / 0.80 = $300,000."
  },
  {
    id: 177,
    question: "What is the federal lead-based paint disclosure rule designed to require from sellers and landlords of many pre-1978 homes?",
    answer: "Disclosure of known lead-based paint hazards and delivery of the required federal information pamphlet.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "The national exam tests not only the 1978 cutoff but also the seller and landlord disclosure obligations tied to older housing."
  },
  {
    id: 178,
    question: "What is radon?",
    answer: "A naturally occurring radioactive gas that can accumulate indoors and pose health risks.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Radon is colorless and odorless, so testing is important when evaluating potential environmental concerns."
  },
  {
    id: 179,
    question: "What is blockbusting?",
    answer: "An illegal practice of inducing owners to sell by suggesting that protected-class members are moving into the neighborhood and property values will decline.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Blockbusting is a classic national fair housing topic because it combines discrimination with unethical solicitation."
  },
  {
    id: 180,
    question: "What is redlining?",
    answer: "An illegal practice of denying or restricting loans or insurance in certain areas based on discriminatory factors rather than legitimate underwriting standards.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Redlining is tested as a discriminatory housing and lending practice that limits equal access to housing opportunity."
  },
  {
    id: 181,
    question: "What is a void contract?",
    answer: "A contract that has no legal effect from the beginning because it lacks a required element or involves an illegal purpose.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "A void contract cannot be enforced by either party because the law treats it as if it never existed."
  },
  {
    id: 182,
    question: "What is a voidable contract?",
    answer: "A contract that is valid unless one of the parties with the legal right to do so chooses to rescind it.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Contracts involving a minor or a party under duress are common examples of potentially voidable agreements."
  },
  {
    id: 183,
    question: "What is specific performance?",
    answer: "A court remedy requiring a party to carry out the contract as agreed.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Because real estate is considered unique, specific performance is a common remedy in disputes involving sales contracts."
  },
  {
    id: 184,
    question: "What is liquidated damages in a real estate contract?",
    answer: "An amount agreed in advance that may be retained or paid if a party breaches the contract.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Earnest money is often discussed in this context because the contract may specify whether the deposit can serve as liquidated damages."
  },
  {
    id: 185,
    question: "What is recording in real estate?",
    answer: "The act of placing a document in the public record to give notice and help protect ownership or lien priority.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Recording does not usually create validity by itself, but it helps establish public notice and priority among competing claims."
  },
  {
    id: 186,
    question: "What is a cloud on title?",
    answer: "An unresolved claim, defect, or encumbrance that may impair ownership or transfer of title.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Clouds on title can include liens, recording errors, unreleased mortgages, or competing ownership claims."
  },
  {
    id: 187,
    question: "What is a quiet title action?",
    answer: "A court action brought to resolve adverse claims and establish clear title to property.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Quiet title actions are used when title defects or competing claims must be resolved before property can be sold or financed cleanly."
  },
  {
    id: 188,
    question: "What is marketable title?",
    answer: "Title that is reasonably free from significant defects and acceptable to a prudent purchaser or lender.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "A buyer usually expects marketable title at closing rather than title burdened by serious unresolved defects."
  },
  {
    id: 189,
    question: "What is an abstract of title?",
    answer: "A summary of the recorded history affecting title to a parcel of real property.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "An abstract compiles the chain of title and recorded matters affecting ownership, though title insurance is more common in many markets today."
  },
  {
    id: 190,
    question: "What is the purpose of a title search?",
    answer: "To examine public records for defects, liens, encumbrances, and ownership issues that may affect title.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "A title search helps identify problems before closing so they can be cleared, disclosed, or insured against where appropriate."
  },
  {
    id: 191,
    question: "What is a debit at closing?",
    answer: "An amount charged against a party on the settlement statement.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Debits increase the amount a party must pay or reduce the amount the party receives at closing."
  },
  {
    id: 192,
    question: "What is a credit at closing?",
    answer: "An amount entered in favor of a party on the settlement statement.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Credits reduce the amount a party must bring to closing or increase the amount the party will receive."
  },
  {
    id: 193,
    question: "What is the difference between prepaid items and accrued items at closing?",
    answer: "Prepaid items are paid in advance and usually credited back to the seller, while accrued items are owed at closing and usually charged to the seller.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "This is a standard proration concept. The key is identifying whether the item has already been paid or is still unpaid as of closing."
  },
  {
    id: 194,
    question: "What is a fixture by adaptation?",
    answer: "Personal property that becomes real property because it is specially adapted or custom-fitted to the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Adaptation is one of the classic tests used to decide whether an item has become a fixture."
  },
  {
    id: 195,
    question: "What is trade fixture?",
    answer: "Personal property installed by a commercial tenant for business purposes that is generally removable before the lease ends.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Trade fixtures are an important exception to the usual rule that attached items become part of the real estate."
  },
  {
    id: 196,
    question: "What is a general lien?",
    answer: "A lien affecting all of a debtor's property, both real and personal, rather than one specific parcel.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Judgment liens are a common example of general liens, while a mortgage is usually a specific lien."
  },
  {
    id: 197,
    question: "What is a specific lien?",
    answer: "A lien that attaches to a particular piece of property rather than all property owned by the debtor.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "A mortgage or property tax lien on a specific parcel is a common example of a specific lien."
  },
  {
    id: 198,
    question: "What is escheat?",
    answer: "The government's power to take ownership of property when a person dies without heirs and without a valid will.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Escheat is one of the four classic government powers over real estate and is often remembered with the PETE acronym."
  },
  {
    id: 199,
    question: "What is condemnation in real estate?",
    answer: "The legal process used to take private property for public use under the power of eminent domain.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Students often confuse eminent domain with condemnation. Eminent domain is the power; condemnation is the process."
  },
  {
    id: 200,
    question: "What is zoning?",
    answer: "A police-power tool that regulates land use, building types, density, and other development limits within designated areas.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Zoning is one of the most frequently tested examples of police power because it directly controls how land may be used."
  },
  {
    id: 201,
    question: "What is a defeasible fee estate?",
    answer: "A fee estate that can be lost if a stated condition is violated or a specified event occurs.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "A defeasible fee is still a freehold estate, but it is subject to a condition that can limit the owner's continued interest."
  },
  {
    id: 202,
    question: "What is a reversion in real estate?",
    answer: "The interest that remains with a grantor after conveying a lesser estate, with possession returning when that lesser estate ends.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "For example, if a grantor gives someone a life estate but keeps the future interest, the property reverts when the life estate ends."
  },
  {
    id: 203,
    question: "What is a remainder interest?",
    answer: "A future interest that takes effect after the end of a prior estate, such as a life estate.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "A remainder goes to a third party designated to take title when the prior estate ends, rather than back to the grantor."
  },
  {
    id: 204,
    question: "What is tenancy at will?",
    answer: "A leasehold estate that continues only as long as both landlord and tenant agree.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "It has no definite ending date and may usually be terminated with proper notice as required by law."
  },
  {
    id: 205,
    question: "What is tenancy at sufferance?",
    answer: "A tenancy created when a tenant remains in possession after the lawful lease term has ended without the landlord's consent.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This is commonly called a holdover tenancy. The landlord may choose to evict or, in some situations, treat the holdover as a new tenancy."
  },
  {
    id: 206,
    question: "What is actual eviction?",
    answer: "The physical or legal removal of a tenant from possession of leased property.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Actual eviction differs from constructive eviction, where the tenant leaves because the premises have become unusable due to the landlord's conduct or failure to act."
  },
  {
    id: 207,
    question: "What is constructive eviction?",
    answer: "A situation in which the landlord's action or inaction makes the premises unusable, causing the tenant to leave.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Constructive eviction is tested because the tenant is not physically removed but is effectively forced out by conditions."
  },
  {
    id: 208,
    question: "What is a lot and block legal description?",
    answer: "A legal description that identifies property by lot number, block number, subdivision name, and recorded plat reference.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Also called the recorded plat method, it is commonly used in developed subdivisions."
  },
  {
    id: 209,
    question: "How many sections are in a township under the rectangular survey system?",
    answer: "36 sections.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "A township is generally a 6-mile-by-6-mile square containing 36 one-mile-square sections."
  },
  {
    id: 210,
    question: "How many acres are in one section of land under the rectangular survey system?",
    answer: "640 acres.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "One section is one square mile, and one square mile contains 640 acres."
  },
  {
    id: 211,
    question: "What is stigmatized property?",
    answer: "Property that may be viewed negatively for reasons unrelated to its physical condition or title, depending on state law and market perception.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Examples can include prior events or public perceptions. Disclosure duties vary by jurisdiction, which is why the national concept is tested carefully."
  },
  {
    id: 212,
    question: "What is asbestos and why is it significant in real estate?",
    answer: "Asbestos is a mineral fiber once used in building materials that can present health risks if disturbed and inhaled.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Asbestos is a common environmental hazard topic because older buildings may contain it in insulation, flooring, and other materials."
  },
  {
    id: 213,
    question: "What is mold as a real estate disclosure issue?",
    answer: "A potential environmental and health concern arising from moisture conditions that may materially affect a property's condition or habitability.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Mold questions often focus on whether the condition is material and whether the licensee knows of it."
  },
  {
    id: 214,
    question: "What is reasonable accommodation under fair housing law?",
    answer: "A change in rules, policies, practices, or services that may be necessary to give a person with a disability equal housing opportunity.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This differs from a reasonable modification, which is a physical change to the property itself."
  },
  {
    id: 215,
    question: "What is reasonable modification under fair housing law?",
    answer: "A physical change to a dwelling or common area that may be necessary for a person with a disability to fully use and enjoy the property.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "Students often confuse modification with accommodation. Modification changes the premises, while accommodation changes rules or services."
  },
  {
    id: 216,
    question: "What is the purpose of fair housing enforcement remedies?",
    answer: "To provide relief when unlawful housing discrimination is proven and to deter future discriminatory conduct.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Fair housing law is tested not just as a list of prohibited conduct, but also as a system with enforcement and remedies."
  },
  {
    id: 217,
    question: "What is the Equal Credit Opportunity Act (ECOA) designed to prohibit?",
    answer: "Discrimination in credit decisions on prohibited bases.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Although it is a credit law rather than a housing sale law, ECOA appears in national real estate exam study because financing discrimination affects housing access."
  },
  {
    id: 218,
    question: "If a broker earns a 3% side of the commission on a $425,000 sale, how much is that side?",
    answer: "$12,750.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply $425,000 by 0.03 to get $12,750."
  },
  {
    id: 219,
    question: "If a property has a gross monthly rent of $2,400, what is the annual gross rent?",
    answer: "$28,800.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the monthly rent by 12. Here, $2,400 x 12 = $28,800."
  },
  {
    id: 220,
    question: "What is the difference between an employee and an independent contractor in a brokerage context?",
    answer: "An employee is subject to greater control over how work is performed, while an independent contractor generally controls the manner and method of work subject to the contract and law.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "This distinction matters for supervision, compensation, and tax treatment, and it appears in national exam prep as a brokerage practice concept."
  },
  {
    id: 221,
    question: "What are the four unities traditionally required for joint tenancy?",
    answer: "Time, title, interest, and possession.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "These four unities help distinguish joint tenancy from tenancy in common and support the right of survivorship."
  },
  {
    id: 222,
    question: "What happens to a joint tenant's interest at death?",
    answer: "It passes automatically to the surviving joint tenant or joint tenants by right of survivorship.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This transfer occurs outside of probate because the survivorship feature controls the passage of the interest."
  },
  {
    id: 223,
    question: "What is partition in co-ownership?",
    answer: "A legal action to divide property among co-owners or, if division is impractical, force its sale and divide the proceeds.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Partition is important because co-owners do not have to remain co-owners forever if they cannot agree."
  },
  {
    id: 224,
    question: "What is an easement by necessity?",
    answer: "An easement implied by law when property would otherwise be landlocked and access is reasonably necessary.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This type of easement is created to avoid rendering land unusable due to lack of access."
  },
  {
    id: 225,
    question: "What is an easement by prescription?",
    answer: "An easement acquired through open, notorious, continuous, and adverse use for the statutory period.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "It is similar in concept to adverse possession, except it creates a right to use rather than ownership of the land."
  },
  {
    id: 226,
    question: "What is a restrictive covenant?",
    answer: "A private restriction that limits how property may be used.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Restrictive covenants are private controls on land use and differ from public controls such as zoning."
  },
  {
    id: 227,
    question: "What is a lis pendens?",
    answer: "A recorded notice that litigation is pending which may affect title to or possession of real property.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "A lis pendens warns potential buyers and lenders that the property may be affected by an ongoing legal dispute."
  },
  {
    id: 228,
    question: "What is a judgment lien?",
    answer: "A lien that may attach to a debtor's property after a court judgment is entered and properly recorded or docketed.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Judgment liens are involuntary liens created by law rather than by the owner's agreement."
  },
  {
    id: 229,
    question: "What is a mechanic's lien?",
    answer: "A lien filed by someone who supplied labor or materials for the improvement of property and was not paid.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Mechanic's liens are common exam material because they arise from construction or repair work on the property."
  },
  {
    id: 230,
    question: "What is subordination in lien priority?",
    answer: "An agreement by which a lienholder voluntarily allows another lien to take priority over its own lien.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Subordination changes the normal order of priority and is important in construction and refinancing contexts."
  },
  {
    id: 231,
    question: "What is the gross rent multiplier (GRM)?",
    answer: "A rough valuation tool found by dividing a property's sale price by its gross rental income.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "GRM is a quick screening tool, not a full appraisal method, because it ignores vacancy, expenses, and financing."
  },
  {
    id: 232,
    question: "What is net operating income (NOI)?",
    answer: "Income remaining after operating expenses are subtracted from gross income, but before debt service and income taxes.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "NOI is central to income-property analysis because it isolates the property's operating performance from financing choices."
  },
  {
    id: 233,
    question: "What is capitalization rate?",
    answer: "A rate used to convert income into value, commonly found by dividing net operating income by value or price.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "The cap rate helps connect a property's income performance to its market value."
  },
  {
    id: 234,
    question: "What is appreciation in real estate?",
    answer: "An increase in property value over time due to market forces, improvements, or other favorable factors.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Appreciation is the opposite of a decline in value and is distinct from tax depreciation, which is an accounting concept."
  },
  {
    id: 235,
    question: "What is a prepaid expense at closing?",
    answer: "An expense that has already been paid in advance and is usually credited back to the payer for the unused portion after closing.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Examples may include prepaid property taxes or insurance, depending on the timing of the closing and billing cycle."
  },
  {
    id: 236,
    question: "What is an accrued expense at closing?",
    answer: "An expense that has been incurred but not yet paid as of closing and is usually charged to the party who benefited from it before closing.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Accrued items commonly include unpaid property taxes or interest earned up to the closing date."
  },
  {
    id: 237,
    question: "What is the purpose of the Americans with Disabilities Act (ADA) in a real estate context?",
    answer: "To require accessibility standards in covered public accommodations and commercial facilities, rather than to govern private residential ownership generally.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Students often confuse the ADA with fair housing law. The ADA primarily addresses accessibility in covered public and commercial settings."
  },
  {
    id: 238,
    question: "What is an optionor in an option contract?",
    answer: "The party who grants the option and is bound to keep the offer open for the option period.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "In a sale option, the seller is often the optionor because the seller grants the buyer the right to purchase."
  },
  {
    id: 239,
    question: "What is an optionee in an option contract?",
    answer: "The party who receives the right to exercise the option within the specified period.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "The optionee has the right, but not the obligation, to exercise the option according to its terms."
  },
  {
    id: 240,
    question: "If a property's annual NOI is $36,000 and the capitalization rate is 9%, what is the indicated value?",
    answer: "$400,000.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by capitalization rate. Here, $36,000 / 0.09 = $400,000."
  },
  {
    id: 241,
    question: "What is adverse possession?",
    answer: "A method of acquiring title to property by open, notorious, continuous, exclusive, and adverse possession for the statutory period.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Adverse possession transfers ownership, unlike a prescriptive easement, which creates only a right to use."
  },
  {
    id: 242,
    question: "What is a probate sale in real estate?",
    answer: "A sale of property from a deceased person's estate through the probate process.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Probate sales are part of title transfer by operation of law or court-supervised process rather than ordinary voluntary transfer alone."
  },
  {
    id: 243,
    question: "What is intestate succession?",
    answer: "The transfer of property according to state law when a person dies without a valid will.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This is distinct from transfer by devise, which occurs under a will."
  },
  {
    id: 244,
    question: "What is a nonconforming use?",
    answer: "A lawful existing use that no longer conforms to current zoning but may continue under applicable rules.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Nonconforming uses are tested because they illustrate how zoning changes can affect existing property rights."
  },
  {
    id: 245,
    question: "What is a variance in zoning?",
    answer: "Permission to deviate from the strict terms of a zoning ordinance when legal requirements for relief are met.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Variances are a classic zoning topic because they are exceptions granted without changing the ordinance itself."
  },
  {
    id: 246,
    question: "What is a building code?",
    answer: "A regulation establishing standards for construction, safety, materials, and building systems.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Building codes are another major example of police power because they protect public health and safety."
  },
  {
    id: 247,
    question: "What is a buffer zone in land-use planning?",
    answer: "An area that separates different land uses to reduce conflict, noise, visual impact, or other incompatibilities.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Buffers are common planning tools used to make neighboring land uses more compatible."
  },
  {
    id: 248,
    question: "What is a designated agency arrangement generally intended to do?",
    answer: "Allow a brokerage to assign one licensee to represent the buyer and another to represent the seller, subject to state law and required disclosures or consent.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "Designated agency is tested because it is often confused with full independent representation, even though the brokerage still has overall agency implications."
  },
  {
    id: 249,
    question: "What is ostensible or apparent agency?",
    answer: "An agency relationship that appears to exist because of the principal's or agent's conduct, even if no actual authority was intended.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "This concept matters because liability can arise from how the relationship appears to third parties, not just from written agreements."
  },
  {
    id: 250,
    question: "What is rescission in contract law?",
    answer: "The cancellation of a contract with the goal of restoring the parties to their positions before the contract.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Rescission is a common remedy when a contract is voidable, induced by misrepresentation, or otherwise legally defective."
  },
  {
    id: 251,
    question: "What is novation in a contract context?",
    answer: "The substitution of a new contract or new party for an old one, with the consent of all parties involved.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "Novation is more than amendment; it replaces an existing obligation with a new one."
  },
  {
    id: 252,
    question: "What is discounting a note?",
    answer: "Selling a promissory note for less than its face amount in order to receive cash immediately.",
    category: "National Financing",
    difficulty: "hard",
    explanation: "The seller of the note accepts less than the note's future face value in exchange for present cash."
  },
  {
    id: 253,
    question: "What is a purchase-money mortgage?",
    answer: "A mortgage given by a buyer to a seller as part of the purchase financing.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "This is a common form of seller financing and is distinct from a traditional institutional loan."
  },
  {
    id: 254,
    question: "What is a package mortgage?",
    answer: "A loan that covers both real property and personal property in one financing arrangement.",
    category: "National Financing",
    difficulty: "hard",
    explanation: "Package mortgages are often tested because they secure more than just the land and improvements."
  },
  {
    id: 255,
    question: "What is a reasonable person standard in disclosure questions?",
    answer: "A standard asking whether a typical prudent person would consider the fact important in deciding how to act.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This standard helps determine whether a fact is material and therefore likely subject to disclosure."
  },
  {
    id: 256,
    question: "What is a latent defect?",
    answer: "A hidden defect that is not readily observable by ordinary inspection.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Latent defects are commonly contrasted with patent defects, which are visible or readily discoverable."
  },
  {
    id: 257,
    question: "What is a patent defect?",
    answer: "A defect that is visible or discoverable by ordinary inspection.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "The distinction between latent and patent defects is frequently tested in disclosure and misrepresentation questions."
  },
  {
    id: 258,
    question: "What is steering distinguished from if an agent simply provides objective information on properties that meet a buyer's stated criteria?",
    answer: "Steering is illegal guidance based on protected characteristics, while providing objective property information based on lawful client criteria is permissible.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This distinction is tested because agents must serve clients without channeling them based on discriminatory assumptions."
  },
  {
    id: 259,
    question: "What is transfer tax or documentary tax at closing?",
    answer: "A tax imposed on certain real estate conveyance documents or transfers, depending on the jurisdiction.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Transfer-related taxes are a common closing-cost concept, though the party responsible varies by state and local law."
  },
  {
    id: 260,
    question: "If a buyer places 15% down on a $320,000 purchase, how much is the down payment?",
    answer: "$48,000.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply $320,000 by 0.15 to get $48,000."
  },
  {
    id: 261,
    question: "What is riparian right?",
    answer: "A water right held by an owner whose land borders a flowing body of water such as a river or stream.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Riparian rights are commonly tested alongside littoral rights, which involve water bordering lakes, seas, or oceans."
  },
  {
    id: 262,
    question: "What is a littoral right?",
    answer: "A water right held by an owner whose land borders a nonflowing body of water such as a lake, sea, or ocean.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "National exams often compare littoral and riparian rights as different forms of water-related property rights."
  },
  {
    id: 263,
    question: "What is accretion?",
    answer: "The gradual addition of land by the deposit of soil through natural water action.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Accretion can increase a parcel's size over time, while erosion is the gradual loss of land."
  },
  {
    id: 264,
    question: "What is avulsion?",
    answer: "A sudden and noticeable loss or addition of land caused by water action.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Avulsion differs from accretion because it is sudden rather than gradual."
  },
  {
    id: 265,
    question: "What is erosion in real estate?",
    answer: "The gradual loss of land by natural causes such as wind or flowing water.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Erosion is the opposite of accretion and is frequently tested in water-rights questions."
  },
  {
    id: 266,
    question: "What is an easement terminated by abandonment?",
    answer: "An easement that ends when the holder clearly demonstrates intent to give up the easement and stops using it.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Mere nonuse is usually not enough by itself; abandonment generally requires clear intent plus conduct."
  },
  {
    id: 267,
    question: "What is an easement terminated by merger?",
    answer: "An easement that ends when the dominant and servient estates come under common ownership.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Once one person owns both parcels, there is no need for one parcel to have an easement over the other."
  },
  {
    id: 268,
    question: "What is an easement terminated by release?",
    answer: "An easement that ends when the easement holder formally gives up the right, usually in writing.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "A release is one common way to terminate an easement when the holder no longer needs or wants it."
  },
  {
    id: 269,
    question: "What is a superior lien?",
    answer: "A lien that has priority over other liens and is paid first from foreclosure or sale proceeds.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Priority determines the order in which claims are satisfied when the property is sold."
  },
  {
    id: 270,
    question: "What is a junior lien?",
    answer: "A lien that has lower priority than a superior lien and is paid only after senior liens are satisfied.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Junior liens carry more risk because they may receive little or nothing if sale proceeds are insufficient."
  },
  {
    id: 271,
    question: "What generally ends a periodic tenancy?",
    answer: "Proper notice given as required by law or the lease terms.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "A periodic tenancy renews automatically until one party properly terminates it."
  },
  {
    id: 272,
    question: "What is a percentage lease?",
    answer: "A commercial lease in which the tenant pays base rent plus a percentage of business revenue.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This lease structure is common in retail properties where rent may rise with the tenant's sales."
  },
  {
    id: 273,
    question: "What is a sandwich lease?",
    answer: "A lease arrangement in which the tenant subleases the property to another tenant while remaining liable to the original landlord.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "The intermediate tenant is both a tenant and a landlord in the chain of leasing."
  },
  {
    id: 274,
    question: "What is a subsection of land under the rectangular survey system if a section is divided into quarters and then one quarter is divided again into quarters?",
    answer: "A 40-acre tract.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "A section is 640 acres. One quarter section is 160 acres, and one quarter of that quarter is 40 acres."
  },
  {
    id: 275,
    question: "What direction does a range indicate in the rectangular survey system?",
    answer: "The east-west location of a township relative to a principal meridian.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Township indicates north-south position relative to a base line, while range indicates east-west position relative to a principal meridian."
  },
  {
    id: 276,
    question: "What direction does a township line indicate in the rectangular survey system?",
    answer: "The north-south location of a township relative to a base line.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This is a standard rectangular-survey distinction tested with township and range descriptions."
  },
  {
    id: 277,
    question: "If a lot measures 100 feet by 150 feet, how many square feet does it contain?",
    answer: "15,000 square feet.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply length by width. Here, 100 x 150 = 15,000 square feet."
  },
  {
    id: 278,
    question: "If a property contains 43,560 square feet, how many acres is it?",
    answer: "1 acre.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "One acre equals 43,560 square feet, which is a foundational national exam conversion."
  },
  {
    id: 279,
    question: "If a buyer obtains an 85% LTV loan on a $500,000 purchase, how much is the down payment?",
    answer: "$75,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "An 85% LTV loan means the loan is $425,000. The down payment is the remaining 15%, or $75,000."
  },
  {
    id: 280,
    question: "If a property's annual gross rent is $30,000 and its sale price is $300,000, what is the gross rent multiplier?",
    answer: "10.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "GRM equals sale price divided by annual gross rent. Here, $300,000 / $30,000 = 10."
  },
  {
    id: 281,
    question: "What is a fee simple absolute estate?",
    answer: "The most complete form of private ownership, with the greatest bundle of rights and no condition limiting duration.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This is the standard ownership estate most buyers think of when purchasing property in fee simple."
  },
  {
    id: 282,
    question: "What is a fee simple determinable estate?",
    answer: "A defeasible fee estate that automatically ends when a stated condition is violated or a specified event occurs.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This differs from a fee simple subject to condition subsequent because termination is automatic rather than requiring action by the grantor."
  },
  {
    id: 283,
    question: "What is a fee simple subject to condition subsequent?",
    answer: "A defeasible fee estate that may be terminated if a stated condition is violated, but it does not end automatically.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "The grantor must usually take action to reclaim the estate after the condition is breached."
  },
  {
    id: 284,
    question: "What is a legal life estate pur autre vie?",
    answer: "A life estate measured by the life of someone other than the life tenant.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This is a more advanced estates concept and appears as a variation on the ordinary life estate."
  },
  {
    id: 285,
    question: "What is community property?",
    answer: "A form of marital property ownership recognized in some states under which most property acquired during marriage is jointly owned by both spouses.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Community property is distinct from tenancy by the entirety and does not apply in every state."
  },
  {
    id: 286,
    question: "What does undivided interest mean in co-ownership?",
    answer: "Each co-owner has a right to use and possess the whole property, not just a physically separated portion.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "An undivided interest means ownership shares are fractional interests in the entire property rather than ownership of separate rooms or sections."
  },
  {
    id: 287,
    question: "What is the difference between title and possession in co-ownership questions?",
    answer: "Title refers to legal ownership rights, while possession refers to the right to occupy or control the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "The exam often tests whether a person can have possession without full title or title without exclusive possession."
  },
  {
    id: 288,
    question: "What is ratification in agency law?",
    answer: "The principal's approval of an act performed on the principal's behalf by someone who lacked authority at the time of the act.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "Ratification can bind the principal to the act if the principal later accepts it with knowledge of the material facts."
  },
  {
    id: 289,
    question: "What is agency by estoppel?",
    answer: "A situation in which a principal may be prevented from denying an agency relationship because the principal's conduct caused a third party to reasonably rely on its existence.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "This concept overlaps with apparent agency and focuses on protecting third parties who were misled by appearances."
  },
  {
    id: 290,
    question: "When does agency terminate by operation of law?",
    answer: "Agency may terminate automatically because of events such as death, incapacity, destruction of the property, or fulfillment of the agency purpose.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "Termination by operation of law does not depend on one party choosing to end the relationship."
  },
  {
    id: 291,
    question: "What is negligent misrepresentation in real estate?",
    answer: "A false statement made carelessly, without reasonable grounds for believing it to be true, that causes another person to rely on it.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Negligent misrepresentation differs from fraud because it does not require intent to deceive."
  },
  {
    id: 292,
    question: "What is puffing in real estate advertising?",
    answer: "Exaggerated opinion or promotional language that is not intended as a factual representation.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Puffing is usually contrasted with misrepresentation, which involves false or misleading statements of material fact."
  },
  {
    id: 293,
    question: "What is a material latent defect?",
    answer: "A hidden condition known to the seller or licensee that could significantly affect value, safety, or desirability.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This combines two common exam ideas: the defect is hidden, and it is material enough that a reasonable person would care about it."
  },
  {
    id: 294,
    question: "What is the settlement date in a real estate transaction?",
    answer: "The date on which the parties complete the closing and the financial adjustments are finalized.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "This is the date used for many proration calculations and final transfer activities."
  },
  {
    id: 295,
    question: "What is a closing cost?",
    answer: "An expense associated with completing a real estate transaction in addition to the purchase price.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Examples include loan fees, title charges, recording fees, transfer taxes, and prepaid items."
  },
  {
    id: 296,
    question: "What is a recording fee at closing?",
    answer: "A charge for placing documents such as deeds or mortgages into the public record.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Recording fees are different from transfer taxes because they are administrative charges for recording documents."
  },
  {
    id: 297,
    question: "What is a special assessment?",
    answer: "A charge against property to pay for a public improvement that specially benefits that property.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Unlike a general property tax, a special assessment is tied to a particular improvement such as paving or sewer installation."
  },
  {
    id: 298,
    question: "What is a subdivision regulation?",
    answer: "A police-power control governing how land may be divided and improved, including streets, utilities, drainage, and lot standards.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Subdivision regulation is a common exam topic because it affects land development before lots are sold."
  },
  {
    id: 299,
    question: "What is a metes-and-bounds point of beginning?",
    answer: "The identifiable starting point from which the parcel's boundary lines are traced in a metes-and-bounds description.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "A valid metes-and-bounds description should return to the point of beginning to fully enclose the parcel."
  },
  {
    id: 300,
    question: "If a buyer pays $18 per square foot for a 2,500-square-foot property, what is the total price?",
    answer: "$45,000.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the price per square foot by the number of square feet. Here, 2,500 x $18 = $45,000."
  },
  {
    id: 301,
    question: "What is a lien waiver?",
    answer: "A document in which a contractor, subcontractor, or supplier gives up the right to file a mechanic's lien for work or materials covered by the waiver.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Lien waivers are commonly used at closing or during construction to reduce the risk of later mechanic's lien claims."
  },
  {
    id: 302,
    question: "What is foreclosure?",
    answer: "The legal process used to enforce a mortgage or other lien against property when the borrower defaults.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Foreclosure allows the property to be sold so the debt can be satisfied from the sale proceeds according to lien priority."
  },
  {
    id: 303,
    question: "What is the equity of redemption?",
    answer: "The borrower's right to reclaim property before foreclosure sale by paying the debt and required costs.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This is a key foreclosure concept because it exists before the foreclosure sale is completed."
  },
  {
    id: 304,
    question: "What is a deficiency judgment?",
    answer: "A court judgment against a borrower for the unpaid debt balance remaining after foreclosure sale proceeds are applied.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "If the foreclosure sale does not generate enough money to satisfy the debt, the lender may seek a deficiency judgment where allowed by law."
  },
  {
    id: 305,
    question: "What is a deed in lieu of foreclosure?",
    answer: "A transfer in which the borrower voluntarily conveys the property to the lender to avoid the foreclosure process.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This may save time and expense, but the lender must consider title condition and any junior liens before accepting it."
  },
  {
    id: 306,
    question: "What is a novation in mortgage financing?",
    answer: "The substitution of a new obligation or new party for an existing one, with consent of all parties, releasing the original obligation.",
    category: "National Financing",
    difficulty: "hard",
    explanation: "This is distinct from a simple assignment or amendment because the prior obligation is replaced rather than merely modified."
  },
  {
    id: 307,
    question: "What is a straight note?",
    answer: "A note under which interest is paid periodically and the principal is paid in one lump sum at maturity.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "A straight note differs from a fully amortized loan because the principal is not gradually reduced through each periodic payment."
  },
  {
    id: 308,
    question: "What is hypothecation?",
    answer: "The pledging of property as security for a debt without giving up possession of the property.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Mortgage financing commonly involves hypothecation because the borrower keeps possession while using the property as collateral."
  },
  {
    id: 309,
    question: "What is a release clause in a mortgage?",
    answer: "A clause allowing specific parcels or lots to be released from a blanket mortgage lien when stated conditions are met.",
    category: "National Financing",
    difficulty: "hard",
    explanation: "This clause is important in development financing because individual parcels may need to be sold free of the blanket lien."
  },
  {
    id: 310,
    question: "What is a blanket mortgage?",
    answer: "A mortgage that covers more than one parcel of real estate.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Blanket mortgages are common in subdivision and development contexts because one loan may secure multiple lots or parcels."
  },
  {
    id: 311,
    question: "What is an amendment to a contract?",
    answer: "A mutually agreed change to one or more terms of an existing contract.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "An amendment modifies the original agreement, while a novation replaces it with a new obligation or party."
  },
  {
    id: 312,
    question: "What is assignment of a contract?",
    answer: "The transfer of one party's contractual rights to another person.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Assignment generally transfers rights, while delegation relates to transferring duties."
  },
  {
    id: 313,
    question: "What is delegation in contract law?",
    answer: "The transfer of one party's contractual duties to another person.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "Delegating performance does not always release the original party from liability unless the other parties agree to a novation."
  },
  {
    id: 314,
    question: "What is a probate court's general role in property transfer?",
    answer: "To supervise the administration of a deceased person's estate, including property distribution and related legal matters.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Probate court involvement is important when title passes through an estate rather than by survivorship or direct lifetime transfer."
  },
  {
    id: 315,
    question: "What is a Certificate of Occupancy generally used to show?",
    answer: "That a building or space has been approved for occupancy or use under applicable building and code requirements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "A Certificate of Occupancy is often required before a building may be lawfully occupied for a particular use."
  },
  {
    id: 316,
    question: "What is a building permit generally required for?",
    answer: "Construction, alteration, or improvement work that must comply with building and safety codes.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Permits are a standard police-power tool used to enforce construction standards before and during work."
  },
  {
    id: 317,
    question: "What is the Interstate Land Sales Full Disclosure Act generally designed to regulate?",
    answer: "Certain interstate sales of subdivided land through disclosure and anti-fraud requirements.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This federal law appears in national exam prep because it protects buyers of certain subdivided land sold across state lines."
  },
  {
    id: 318,
    question: "What is familial status under the federal Fair Housing Act?",
    answer: "Protection for households that include one or more individuals under 18 living with a parent, legal custodian, or designee, as well as pregnant persons and those securing custody of a child.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This protected class is commonly tested because it is broader than simply 'having children in the home today.'"
  },
  {
    id: 319,
    question: "If a seller owns property for 9 months of a tax year and annual taxes are $6,000, what is the seller's share before proration adjustments?",
    answer: "$4,500.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Nine months is 9/12 of the year. Multiply $6,000 by 9/12 to get $4,500."
  },
  {
    id: 320,
    question: "If a property is sold for $525,000 with a 5% commission split evenly between two brokerages, how much does each brokerage receive before internal splits?",
    answer: "$13,125.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "First find total commission: $525,000 x 0.05 = $26,250. Then divide by 2 to get $13,125 for each brokerage."
  },
  {
    id: 321,
    question: "What is a tenancy in common owner's right regarding transfer of that owner's interest?",
    answer: "A tenant in common may usually sell, convey, mortgage, or devise that owner's individual interest without consent of the other co-owners.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This is a key distinction from some other ownership arrangements because a tenancy in common interest is separately transferable and inheritable."
  },
  {
    id: 322,
    question: "What is the right of survivorship in joint tenancy intended to do?",
    answer: "Pass a deceased joint tenant's interest automatically to the surviving joint tenant or joint tenants.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This avoids probate for the deceased joint tenant's interest and is the defining feature that distinguishes joint tenancy from tenancy in common."
  },
  {
    id: 323,
    question: "What is a severance of joint tenancy?",
    answer: "An act that breaks one or more of the required unities, converting the affected interest into a tenancy in common in many jurisdictions.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Because joint tenancy depends on the unities and survivorship, transferring one tenant's interest can sever the joint tenancy as to that share."
  },
  {
    id: 324,
    question: "What is annexation in fixture analysis?",
    answer: "The manner and degree of attachment of an item to the land or building.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Annexation is one of the classic tests used to determine whether personal property has become a fixture."
  },
  {
    id: 325,
    question: "What is emblements in property law?",
    answer: "Annual crops produced by cultivation that are generally treated as personal property.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Emblements are an exception to the general rule that things attached to land are part of the real estate."
  },
  {
    id: 326,
    question: "What is a support easement?",
    answer: "An easement that gives one property the right to receive structural support from adjoining land or buildings.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Support rights may matter in dense development or where adjoining structures depend on one another physically."
  },
  {
    id: 327,
    question: "What is an encumbrance by deed restriction?",
    answer: "A private limitation in a deed that restricts how the property may be used or improved.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Deed restrictions are a form of private land-use control and can affect the property's value and marketability."
  },
  {
    id: 328,
    question: "What is an affirmative easement?",
    answer: "An easement that allows the holder to do something on another person's land, such as cross it.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This contrasts with a negative easement, which restricts the servient owner's use rather than allowing affirmative use."
  },
  {
    id: 329,
    question: "What is a negative easement?",
    answer: "An easement that restricts the owner of the servient estate from doing something that would otherwise be lawful.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "For example, a negative easement may prevent blocking light, air, or a view where recognized by law."
  },
  {
    id: 330,
    question: "What is a benchmark in a metes-and-bounds or survey context?",
    answer: "A permanent reference point used by surveyors to establish elevation or location measurements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Benchmarks help surveyors tie measurements to established physical reference points."
  },
  {
    id: 331,
    question: "What is a monument in a legal description?",
    answer: "A fixed natural or artificial object used as a reference point in describing land boundaries.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Monuments can include items such as stakes, roads, streams, or marked survey points."
  },
  {
    id: 332,
    question: "What does 'metes' refer to in a metes-and-bounds description?",
    answer: "Distance measurements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "In this system, metes refers to distance and bounds refers to directions or boundary references."
  },
  {
    id: 333,
    question: "What does 'bounds' refer to in a metes-and-bounds description?",
    answer: "The directions or boundary references that define the parcel's limits.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Bounds work together with metes to trace the parcel from the point of beginning and back again."
  },
  {
    id: 334,
    question: "What is a graduated lease?",
    answer: "A lease in which rent increases at set times or according to a stated schedule.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Graduated leases are common where parties expect inflation, rising costs, or increased property value over time."
  },
  {
    id: 335,
    question: "What is a sublease?",
    answer: "A lease in which the tenant transfers less than the entire leasehold interest to another tenant.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "In a sublease, the original tenant usually remains liable to the original landlord under the original lease."
  },
  {
    id: 336,
    question: "What is an assignment of lease?",
    answer: "A transfer by a tenant of the entire remaining leasehold interest to another party.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This differs from a sublease because the tenant transfers the full remaining lease term rather than keeping a reversionary interest."
  },
  {
    id: 337,
    question: "What is reconciliation in appraisal?",
    answer: "The appraiser's process of weighing the different value indications and arriving at a final opinion of value.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Reconciliation does not simply average the approaches. It involves judging which approaches are most reliable for the subject property."
  },
  {
    id: 338,
    question: "What is highest and best use in appraisal?",
    answer: "The reasonably probable and legal use of property that is physically possible, financially feasible, and maximally productive.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Highest and best use is a foundational appraisal concept because value depends heavily on the most productive legal use of the property."
  },
  {
    id: 339,
    question: "What is a closing prorate for an accrued expense intended to do?",
    answer: "Charge the seller for the portion of the unpaid expense attributable to the seller's period of ownership and credit the buyer for taking over payment after closing.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "This proration logic is tested because students must understand who benefited from the expense before and after closing."
  },
  {
    id: 340,
    question: "If monthly rent is $1,850 and a tenant occupies the property for 10 months, what total rent is paid before any other charges?",
    answer: "$18,500.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the monthly rent by the number of months. Here, $1,850 x 10 = $18,500."
  },
  {
    id: 341,
    question: "What is involuntary alienation of property?",
    answer: "A transfer of property without the owner's consent, such as through foreclosure, tax sale, condemnation, or escheat.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This contrasts with voluntary alienation, where the owner intentionally transfers the property by deed or will."
  },
  {
    id: 342,
    question: "What is voluntary alienation of property?",
    answer: "A transfer of property made intentionally by the owner, such as by sale, gift, or will.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Voluntary alienation occurs when the owner chooses to transfer title rather than losing it by operation of law."
  },
  {
    id: 343,
    question: "What is devise in real estate?",
    answer: "The transfer of real property by will.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Students often pair devise with descent: devise is by will, while descent is by law when there is no valid will."
  },
  {
    id: 344,
    question: "What is estoppel by deed?",
    answer: "A doctrine preventing a grantor from denying the effectiveness of a deed if the grantor later acquires the interest that was purportedly conveyed.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "This concept appears in title questions where someone conveys more interest than they presently own and later acquires that missing interest."
  },
  {
    id: 345,
    question: "What is a net listing?",
    answer: "A listing arrangement in which the seller seeks a specified net amount and the broker keeps any excess as compensation, creating significant conflict-of-interest concerns.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "National exams usually test net listings as ethically problematic because the broker's incentive may diverge from the seller's best interests."
  },
  {
    id: 346,
    question: "What is procuring cause in a brokerage transaction?",
    answer: "The broker or agent whose efforts set in motion an uninterrupted chain of events that leads to the completed transaction.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "This concept is important in commission disputes, especially where multiple brokers or listing arrangements are involved."
  },
  {
    id: 347,
    question: "What is the difference between an amendment and an addendum to a contract?",
    answer: "An amendment changes an existing contract after it has been formed, while an addendum adds terms that become part of the agreement, often at or before execution.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Both alter the parties' written agreement, but exams often distinguish whether the change occurred before or after the original contract was finalized."
  },
  {
    id: 348,
    question: "What is an unenforceable contract?",
    answer: "A contract that may be valid in substance but cannot be enforced in court because of a legal defense such as the Statute of Frauds or expiration of the limitations period.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "This differs from a void contract, which has no legal effect from the outset."
  },
  {
    id: 349,
    question: "Which bundle-of-rights element allows an owner to sell, lease, or give away the property?",
    answer: "The right of disposition.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Disposition is the ownership right that permits transfer of all or part of the property interest."
  },
  {
    id: 350,
    question: "What is situs in real estate?",
    answer: "The economic location of property, including the characteristics of the surrounding area that influence value.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Situs is more than the physical location alone; it includes the desirability and utility of that location in the market."
  },
  {
    id: 351,
    question: "What is the appraisal principle of substitution?",
    answer: "The principle that a buyer will not pay more for a property than the cost of acquiring an equally desirable substitute.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Substitution underlies the sales comparison approach because buyers compare similar properties in the market."
  },
  {
    id: 352,
    question: "What is the appraisal principle of conformity?",
    answer: "The principle that value is maximized when a property is reasonably similar in style, quality, and use to surrounding properties.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Properties that fit their surroundings often benefit from greater market acceptance and stronger value support."
  },
  {
    id: 353,
    question: "What is the appraisal principle of progression?",
    answer: "The idea that a lesser-quality property may gain value when located among better-quality properties.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Progression is commonly tested together with regression, which is the opposite effect."
  },
  {
    id: 354,
    question: "What is the appraisal principle of regression?",
    answer: "The idea that a higher-quality property may lose value when located among lower-quality properties.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Regression shows how surrounding properties can negatively influence value."
  },
  {
    id: 355,
    question: "What is a discount point in mortgage lending?",
    answer: "A fee equal to 1 percent of the loan amount, often paid to adjust the lender's yield on the loan.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Points are prepaid finance charges and are a standard national exam topic in mortgage-cost questions."
  },
  {
    id: 356,
    question: "What is the Real Estate Settlement Procedures Act's prohibition on kickbacks intended to prevent?",
    answer: "Referral-fee arrangements that improperly increase settlement costs or distort consumer choice in covered mortgage transactions.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "RESPA aims to protect consumers from hidden referral arrangements that affect the settlement process."
  },
  {
    id: 357,
    question: "What is a lease option?",
    answer: "A lease that gives the tenant the option, but not the obligation, to purchase the property under stated terms within a stated time.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "A lease option combines a tenancy with a purchase option, unlike a lease purchase that may obligate the tenant to buy."
  },
  {
    id: 358,
    question: "What is a lease purchase?",
    answer: "An arrangement combining a lease with an agreement that commits the tenant to purchase the property under stated terms.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Students often confuse lease purchase with lease option. The key difference is obligation versus choice."
  },
  {
    id: 359,
    question: "What is a purchase agreement disclosure about agency intended to do generally?",
    answer: "Clarify whom the licensee represents and what duties are owed in the transaction.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "Nationally, agency-disclosure requirements vary by state, but the exam still tests the purpose of disclosing agency relationships."
  },
  {
    id: 360,
    question: "If a commission is 7% on a $280,000 sale, what is the total commission?",
    answer: "$19,600.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the sale price by the commission rate. Here, $280,000 x 0.07 = $19,600."
  },
  {
    id: 361,
    question: "What is a vested remainder?",
    answer: "A remainder interest given to an identifiable person without a condition precedent other than the natural end of the prior estate.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "A vested remainder is more secure than a contingent remainder because the remainderman is known and no additional condition must be met."
  },
  {
    id: 362,
    question: "What is a contingent remainder?",
    answer: "A future interest that depends on an uncertain event or on the identity of the remainderman becoming certain.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "The remainder is contingent if the future taker is not yet certain or if a condition precedent must occur before the interest becomes possessory."
  },
  {
    id: 363,
    question: "What is a less-than-freehold estate?",
    answer: "A leasehold estate that gives the right to possess property for a limited period without transferring ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This is another way to describe a nonfreehold interest such as an estate for years or periodic tenancy."
  },
  {
    id: 364,
    question: "What is concurrent ownership?",
    answer: "Ownership of the same property by two or more parties at the same time.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Tenancy in common, joint tenancy, and in some states tenancy by the entirety are forms of concurrent ownership."
  },
  {
    id: 365,
    question: "What is severalty in property ownership?",
    answer: "Ownership by one person or one legal entity alone.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Despite the name, severalty does not mean multiple owners. It means sole ownership."
  },
  {
    id: 366,
    question: "What is a severance of tenancy by one tenant in common generally allowed to do?",
    answer: "A tenant in common may usually transfer or encumber that tenant's own undivided interest without affecting the ownership rights of the others.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This reflects the separate transferability of each tenancy in common interest."
  },
  {
    id: 367,
    question: "What is an easement by condemnation?",
    answer: "An easement created by government action under eminent domain for public use, such as utility or access purposes.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Not all public takings transfer full ownership; some create only a right to use part of the property."
  },
  {
    id: 368,
    question: "What is a party wall easement?",
    answer: "An easement giving adjoining owners reciprocal rights in a shared wall located on or near a property boundary.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Party wall rights are important in attached structures because each owner has support and use interests in the common wall."
  },
  {
    id: 369,
    question: "What is a private restriction compared with a public restriction?",
    answer: "A private restriction arises from agreements or deed covenants between private parties, while a public restriction comes from government powers such as zoning or building codes.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This distinction is heavily tested because both can limit land use but arise from different legal sources."
  },
  {
    id: 370,
    question: "What is an attachment lien?",
    answer: "A lien placed on property during litigation to preserve assets that may later be used to satisfy a judgment.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Attachment liens are provisional remedies and differ from judgment liens, which arise after judgment is entered."
  },
  {
    id: 371,
    question: "What is a writ of execution in lien enforcement?",
    answer: "A court order authorizing an officer such as a sheriff to seize and sell property to satisfy a judgment.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "This is part of judgment enforcement and commonly appears in questions about involuntary liens and creditor remedies."
  },
  {
    id: 372,
    question: "What is a homestead exemption generally intended to do?",
    answer: "Provide qualifying homeowners with some protection from certain creditors and, in some jurisdictions, tax benefits on a primary residence.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "The exact scope varies by state, but the national concept is that a principal residence may receive special legal protection."
  },
  {
    id: 373,
    question: "What is a building line or setback requirement?",
    answer: "A regulation limiting how close a building may be placed to a property line, street, or other boundary.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Setbacks are common zoning controls affecting building placement on a lot."
  },
  {
    id: 374,
    question: "What is a zoning ordinance?",
    answer: "A local law that divides land into zones and regulates permitted uses, density, setbacks, and other development standards.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "The zoning ordinance is the legal framework, while zoning maps and administrative bodies help apply it."
  },
  {
    id: 375,
    question: "What is a zoning map?",
    answer: "A map showing the boundaries of zoning districts and the locations where different zoning classifications apply.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Students should distinguish the zoning map from the zoning ordinance itself; the map shows where the rules apply."
  },
  {
    id: 376,
    question: "What is fraud in a real estate disclosure context?",
    answer: "An intentional misrepresentation or concealment of a material fact made to induce another person to rely on it.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "Fraud requires intent, which distinguishes it from negligent misrepresentation or innocent mistake."
  },
  {
    id: 377,
    question: "What is caveat emptor?",
    answer: "A doctrine meaning 'let the buyer beware,' under which buyers historically bore much of the responsibility to inspect property.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Modern disclosure laws and fraud rules have limited the reach of pure caveat emptor in many situations."
  },
  {
    id: 378,
    question: "What is a stigmatized property issue typically testing on a national exam?",
    answer: "Whether the student understands that some nonphysical conditions may affect market perception and that disclosure duties can vary by state law.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This is usually tested as a disclosure-nuance concept rather than as a uniform nationwide disclosure rule."
  },
  {
    id: 379,
    question: "What is surrender of lease?",
    answer: "The giving up of a leasehold interest by the tenant to the landlord so the lease ends before its scheduled expiration.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Surrender may be express or implied by conduct showing that both parties treat the lease as ended."
  },
  {
    id: 380,
    question: "If a property tax is $7,200 per year, what is the daily tax amount using a 360-day year?",
    answer: "$20 per day.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Divide the annual tax by 360. Here, $7,200 / 360 = $20."
  },
  {
    id: 381,
    question: "What is a freehold estate?",
    answer: "An estate in land that includes ownership rights for an uncertain duration, such as fee simple or a life estate.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Freehold estates differ from leasehold estates, which give possession for a limited time without conveying ownership."
  },
  {
    id: 382,
    question: "What is a nonfreehold estate?",
    answer: "A leasehold estate that gives possession of property for a limited period without ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Nonfreehold is another term for leasehold and includes estates for years, periodic tenancies, tenancy at will, and tenancy at sufferance."
  },
  {
    id: 383,
    question: "What is a legal disability in contract or title questions?",
    answer: "A condition, such as minority or mental incapacity, that can affect a person's ability to enter into binding legal agreements.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Legal disability questions often appear in determining whether a contract is valid, void, or voidable."
  },
  {
    id: 384,
    question: "What is a general partner's typical liability in a partnership?",
    answer: "A general partner is typically personally liable for partnership obligations.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This is relevant in ownership and business-form questions because liability differs among sole proprietorships, partnerships, corporations, and LLCs."
  },
  {
    id: 385,
    question: "What is a limited partner's typical role in a limited partnership?",
    answer: "A limited partner usually contributes capital and has limited liability, but typically does not participate in active management like a general partner.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Limited partnership questions test how ownership interests and liability exposure differ among business forms."
  },
  {
    id: 386,
    question: "What is an LLC in real estate ownership?",
    answer: "A limited liability company, a business entity that generally provides liability protection while allowing flexible ownership and management structure.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "LLCs are common in real estate ownership because they can combine operational flexibility with liability protection."
  },
  {
    id: 387,
    question: "What is color of title?",
    answer: "A claim to title based on a written instrument or record that appears valid but may actually be defective.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Color of title often appears in questions involving adverse possession or defective conveyance."
  },
  {
    id: 388,
    question: "What is a cloud caused by an unreleased mortgage?",
    answer: "A title defect created when the public record still shows a mortgage lien that should have been removed after payoff.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Unreleased liens can make title unmarketable until they are properly cleared from the record."
  },
  {
    id: 389,
    question: "What is the purpose of a satisfaction of mortgage?",
    answer: "To show that the mortgage debt has been paid and the lien should be released from the public record.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Paying off a loan is not enough by itself; the record should also show that the lien has been satisfied."
  },
  {
    id: 390,
    question: "What is a right of support in land ownership?",
    answer: "The right to have adjoining land support one's own land in its natural state.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Support rights often arise in boundary and excavation disputes where one owner's actions may affect neighboring land."
  },
  {
    id: 391,
    question: "What is a tax lien sale generally intended to do?",
    answer: "Collect delinquent property taxes by selling a tax lien, tax certificate, or sometimes the property itself, depending on state law.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "The exam typically focuses on the basic principle that unpaid property taxes can lead to enforced collection and loss of property rights."
  },
  {
    id: 392,
    question: "What is police power intended to protect?",
    answer: "Public health, safety, morals, and general welfare.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "This is the standard definition behind zoning, building codes, environmental regulation, and many land-use controls."
  },
  {
    id: 393,
    question: "What is a variance most commonly granted because of?",
    answer: "A qualifying hardship or practical difficulty under applicable zoning law.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "The exact legal standard varies, but the exam tests the basic idea that a variance is relief from strict application of zoning requirements."
  },
  {
    id: 394,
    question: "What is an environmental impact statement generally used for?",
    answer: "To analyze the likely environmental effects of a proposed project or governmental action before approval.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Environmental review questions test the broader police-power role of government in land-use planning and development."
  },
  {
    id: 395,
    question: "What is a legal nonconforming use?",
    answer: "A use that lawfully existed before a zoning change and is allowed to continue even though it no longer meets current zoning requirements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This is another way of describing a grandfathered use under zoning."
  },
  {
    id: 396,
    question: "What is a variance distinguished from?",
    answer: "A variance grants relief from zoning rules, while rezoning changes the zoning classification itself.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "This distinction is heavily tested because students often confuse an exception to the rules with a change in the rules."
  },
  {
    id: 397,
    question: "What is a stigmatized-property question often really testing?",
    answer: "Whether a candidate understands that not every psychologically affected condition is a uniform national disclosure requirement and that state law may control.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This helps students avoid overgeneralizing disclosure duties where the law varies by jurisdiction."
  },
  {
    id: 398,
    question: "What is asbestos generally considered in disclosure analysis?",
    answer: "A material environmental hazard that may need to be addressed if known and relevant to the transaction.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "National exam questions focus on recognizing asbestos as a potential hazard rather than on technical remediation procedures."
  },
  {
    id: 399,
    question: "What is the purpose of the federal Fair Housing Act's familial-status protection?",
    answer: "To prevent discrimination against households with children and certain people expecting or seeking custody of children.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Familial status is one of the core federal protected classes and is commonly tested because it is often misunderstood."
  },
  {
    id: 400,
    question: "If a property's value is $360,000 and the capitalization rate is 12%, what is the annual NOI?",
    answer: "$43,200.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "NOI equals value multiplied by capitalization rate. Here, $360,000 x 0.12 = $43,200."
  },
  {
    id: 401,
    question: "What is a principal meridian in the rectangular survey system?",
    answer: "A north-south reference line used to locate townships east or west by range.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "The principal meridian works with the base line, which runs east-west, to form the rectangular survey grid."
  },
  {
    id: 402,
    question: "What is a base line in the rectangular survey system?",
    answer: "An east-west reference line used to locate townships north or south.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "The base line and principal meridian are the starting references for legal descriptions under the government survey system."
  },
  {
    id: 403,
    question: "What is a township under the rectangular survey system?",
    answer: "A square tract of land generally measuring 6 miles on each side and containing 36 sections.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "This is a foundational survey-system concept and often appears in acreage and section questions."
  },
  {
    id: 404,
    question: "How many acres are in a quarter section of land?",
    answer: "160 acres.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "A section contains 640 acres, so one quarter of a section contains 160 acres."
  },
  {
    id: 405,
    question: "What is an open listing?",
    answer: "A nonexclusive listing in which the seller may work with multiple brokers and pays a commission only to the broker who is the procuring cause of the sale.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "An open listing offers the least protection to a broker because the seller can also sell without owing a commission to a broker who was not the procuring cause."
  },
  {
    id: 406,
    question: "What is an exclusive right-to-sell listing?",
    answer: "A listing giving one broker the right to earn a commission if the property sells during the listing term, no matter who finds the buyer.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "This is generally the most protective listing for the broker because the owner usually still owes the commission even if the owner finds the buyer."
  },
  {
    id: 407,
    question: "What is an exclusive agency listing?",
    answer: "A listing in which one broker represents the seller, but the seller may avoid paying a commission if the seller alone finds the buyer.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "This differs from an exclusive right-to-sell listing because the seller retains the ability to avoid a commission if no broker is the procuring cause."
  },
  {
    id: 408,
    question: "What is a multiple listing service (MLS)?",
    answer: "A cooperative information-sharing system used by participating brokers to market listings and offer compensation through the service rules.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "The MLS is not itself a type of agency, but it plays a major role in how brokers cooperate and expose listings to other professionals."
  },
  {
    id: 409,
    question: "What is the purpose of a fair housing complaint process?",
    answer: "To investigate and address alleged discriminatory housing practices and provide a legal remedy where discrimination is proven.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "National exam questions may test the idea that fair housing law includes enforcement mechanisms, not just prohibited conduct."
  },
  {
    id: 410,
    question: "What is a protected class in fair housing law?",
    answer: "A group protected by law from discrimination in housing-related activities.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Federal law defines core protected classes, and many states and localities add additional protections."
  },
  {
    id: 411,
    question: "What is discriminatory advertising in fair housing?",
    answer: "Advertising that indicates a preference, limitation, or discrimination based on a protected characteristic.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This can violate fair housing law even before a sale or rental decision is made."
  },
  {
    id: 412,
    question: "What is the purpose of earnest money on a settlement statement?",
    answer: "To credit the buyer for deposit funds already paid toward the purchase.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Because the buyer already paid the earnest money earlier, it is typically shown as a credit to the buyer at closing."
  },
  {
    id: 413,
    question: "What is a lender credit at closing?",
    answer: "An amount the lender agrees to contribute toward a borrower's closing costs, usually in exchange for loan pricing terms.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Lender credits reduce the borrower's cash needed at closing, though they may affect the interest rate or other loan terms."
  },
  {
    id: 414,
    question: "What is a seller concession at closing?",
    answer: "An amount the seller agrees to pay or credit toward the buyer's allowable closing costs or financing expenses.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Seller concessions can make a transaction more affordable for the buyer, subject to loan-program and contract limits."
  },
  {
    id: 415,
    question: "What is gross income multiplier (GIM)?",
    answer: "A broad income multiplier found by dividing a property's sale price by its gross income, which may include more than rental income alone.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "GIM is similar to GRM but broader because GRM typically focuses only on gross rent."
  },
  {
    id: 416,
    question: "What is accrued depreciation in appraisal?",
    answer: "The total loss in value from all causes as of the effective date of the appraisal.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Accrued depreciation combines physical deterioration, functional obsolescence, and external obsolescence."
  },
  {
    id: 417,
    question: "What is a variable lease?",
    answer: "A lease in which rent may change based on an index, sales volume, expense changes, or another stated formula.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Variable leases are designed to adjust over time rather than remain fixed for the full term."
  },
  {
    id: 418,
    question: "What is a net-net-net lease, often called a triple net lease?",
    answer: "A lease in which the tenant pays rent plus property taxes, insurance, and maintenance or operating expenses as specified in the lease.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Triple net leases are common in commercial property because they shift many ownership expenses to the tenant."
  },
  {
    id: 419,
    question: "What is a release of earnest money dispute generally intended to do?",
    answer: "Resolve who is entitled to the deposit when the transaction does not close.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Earnest money disputes are common contract-and-closing problems, especially when contingencies or default issues arise."
  },
  {
    id: 420,
    question: "If a property has a sale price of $450,000 and the buyer makes a 20% down payment, what is the loan amount?",
    answer: "$360,000.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "A 20% down payment is $90,000. Subtract that from $450,000 to get a loan amount of $360,000."
  },
  {
    id: 421,
    question: "What is air right in real estate ownership?",
    answer: "The right to use, control, or transfer the space above the surface of the land, subject to law and reasonable limitations.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Air rights are part of the broader concept that ownership can include interests above and below the land surface."
  },
  {
    id: 422,
    question: "What are subsurface rights?",
    answer: "Rights to the space beneath the land surface, including rights to minerals or other underground resources where not separately conveyed.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Subsurface rights may be owned separately from surface rights, which makes them a common exam topic in ownership questions."
  },
  {
    id: 423,
    question: "What is a fixture by agreement?",
    answer: "An item treated as real or personal property based on the parties' agreement, even when physical attachment might suggest otherwise.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Exam questions often test whether a written agreement can control how an item is classified between the parties."
  },
  {
    id: 424,
    question: "What is a fee simple subject to executory limitation?",
    answer: "A defeasible fee estate that automatically shifts to a third party upon the occurrence of a stated event.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This differs from a fee simple determinable, where the estate returns to the grantor rather than shifting to someone else."
  },
  {
    id: 425,
    question: "What is a legal future interest retained by a grantor called when property may return upon breach of a condition?",
    answer: "A possibility of reverter or a right of re-entry, depending on the type of defeasible fee created.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "These interests are classic exam distinctions tied to determinable fees and fees subject to condition subsequent."
  },
  {
    id: 426,
    question: "What is a landlord's lien in general terms?",
    answer: "A lien right that may arise by law or agreement to secure unpaid rent or other tenant obligations, depending on jurisdiction.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Because landlord-lien rules vary, national exam questions usually focus on the basic concept rather than state-specific enforcement details."
  },
  {
    id: 427,
    question: "What is an income tax lien?",
    answer: "A lien imposed for unpaid income taxes that may attach to a taxpayer's property interests.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Tax liens are involuntary liens and are tested as part of creditor-priority and lien-classification questions."
  },
  {
    id: 428,
    question: "What is an inheritance tax generally based on?",
    answer: "The right to receive property from a deceased person, with liability often depending on the recipient and the jurisdiction.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "This differs conceptually from an estate tax, which is imposed on the decedent's estate before distribution."
  },
  {
    id: 429,
    question: "What is an estate tax generally based on?",
    answer: "The value of a deceased person's taxable estate before distribution to heirs or devisees.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "The exam may contrast estate taxes with inheritance taxes, which focus on the recipient rather than the estate itself."
  },
  {
    id: 430,
    question: "What is a spot zoning concern?",
    answer: "A concern that a small parcel is being zoned differently from surrounding property primarily to benefit a particular owner rather than the public plan.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Spot zoning is tested as a contrast to legitimate comprehensive planning."
  },
  {
    id: 431,
    question: "What is an amendment to a zoning ordinance?",
    answer: "A formal change to the zoning law or map that alters the regulations or classification applicable to property.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This is different from a variance, which grants relief from the ordinance without changing the ordinance itself."
  },
  {
    id: 432,
    question: "What is a conditional use or special use permit?",
    answer: "Permission to use property in a way specifically allowed by zoning if stated conditions and approval requirements are satisfied.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This differs from a variance because the use is contemplated by the ordinance, provided conditions are met."
  },
  {
    id: 433,
    question: "What is downzoning?",
    answer: "A zoning change that reduces the permitted intensity or density of land use.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Downzoning can reduce development potential and is a tested land-use term in planning and zoning questions."
  },
  {
    id: 434,
    question: "What is upzoning?",
    answer: "A zoning change that increases the permitted intensity, density, or development potential of land use.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Upzoning is often discussed as the opposite of downzoning and may affect value and permitted use."
  },
  {
    id: 435,
    question: "What is a certificate of title?",
    answer: "A statement by a title company, attorney, or authority indicating the condition of title after examination of the record.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "A certificate of title differs from title insurance because it is an opinion or certification rather than an insurance policy against certain losses."
  },
  {
    id: 436,
    question: "What is a title defect created by a forged deed?",
    answer: "A forged deed generally creates a serious title defect because a forged conveyance is not effective to transfer valid title.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Forgery is a classic title problem because even subsequent parties may face defects if the chain of title includes an invalid deed."
  },
  {
    id: 437,
    question: "What is an unrecorded deed's main risk?",
    answer: "It may be valid between the parties but can lose priority to a later purchaser or creditor protected by the recording laws.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This is why recording is important even when the deed itself has already been delivered."
  },
  {
    id: 438,
    question: "What is inverse condemnation?",
    answer: "A claim by a property owner that government action has effectively taken property rights without formal condemnation or just compensation.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Inverse condemnation flips the usual eminent-domain process because the owner brings the claim rather than the government initiating condemnation."
  },
  {
    id: 439,
    question: "What is the difference between a lease and a license in property law?",
    answer: "A lease gives the right to exclusive possession for a term, while a license is merely permission to use property without creating a leasehold estate.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This distinction matters because a license usually provides fewer possessory rights and less legal protection than a lease."
  },
  {
    id: 440,
    question: "If a 160-acre tract is sold at $3,200 per acre, what is the total price?",
    answer: "$512,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Multiply the acreage by the per-acre price. Here, 160 x $3,200 = $512,000."
  },
  {
    id: 441,
    question: "What is a fixture by intention?",
    answer: "An item that may be considered a fixture because the parties intended it to become a permanent part of the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Intent is one of the most important fixture tests because courts often look at whether the item was meant to remain with the property."
  },
  {
    id: 442,
    question: "What is a condition precedent in a future-interest context?",
    answer: "A condition that must occur before an estate or interest becomes possessory or enforceable.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This concept often appears in contingent-remainder questions because the future interest depends on an event occurring first."
  },
  {
    id: 443,
    question: "What is the difference between a vested remainder and a reversion?",
    answer: "A vested remainder passes to a third party after the prior estate ends, while a reversion returns the property to the grantor or the grantor's heirs.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This is a classic future-interest distinction because both follow a prior estate but go to different parties."
  },
  {
    id: 444,
    question: "What is a concurrent estate?",
    answer: "An estate held by two or more persons at the same time.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This is another way to describe forms of shared ownership such as tenancy in common or joint tenancy."
  },
  {
    id: 445,
    question: "What is a unity of possession?",
    answer: "The principle that each co-owner has an equal right to possess and use the whole property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Unity of possession is essential to common forms of co-ownership and helps explain why co-owners share rights in the entire parcel."
  },
  {
    id: 446,
    question: "What is an easement for ingress and egress?",
    answer: "An easement that provides the right to enter and exit property across another parcel.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "This is one of the most common practical easement types because it deals with access."
  },
  {
    id: 447,
    question: "What is a utility easement?",
    answer: "An easement allowing a utility company to install, maintain, or repair utility lines or facilities on the property.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Utility easements are commonly easements in gross because they benefit the company rather than a neighboring parcel."
  },
  {
    id: 448,
    question: "What is a negative covenant in land use?",
    answer: "A promise restricting the owner from certain uses or actions on the property.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Negative covenants are private restrictions and often appear in subdivision deed restrictions or restrictive covenant questions."
  },
  {
    id: 449,
    question: "What is external depreciation in appraisal usually caused by?",
    answer: "Negative influences outside the property, such as neighborhood decline, nuisance conditions, or adverse nearby land uses.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "External depreciation is generally considered difficult or impossible for the owner alone to cure because the cause is outside the property."
  },
  {
    id: 450,
    question: "What is the appraisal principle of anticipation?",
    answer: "The principle that value is created by the expectation of future benefits such as income or utility.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "This principle is central to investment-property valuation because buyers pay for expected future benefits."
  },
  {
    id: 451,
    question: "What is the appraisal principle of contribution?",
    answer: "The principle that the value of a component is measured by how much it adds to or subtracts from the value of the whole property.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Contribution explains why the cost of an improvement does not always equal the amount of value it adds."
  },
  {
    id: 452,
    question: "What is the difference between fair housing steering and lawful client service?",
    answer: "Steering unlawfully directs clients based on protected characteristics, while lawful service responds to objective client criteria without discriminatory assumptions.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This distinction is important because agents must provide service without channeling clients by race, religion, familial status, or other protected categories."
  },
  {
    id: 453,
    question: "What is a handicap or disability accommodation question usually testing in fair housing?",
    answer: "Whether the candidate can distinguish lawful equal-access accommodations from discriminatory refusal or unequal treatment.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "These questions often turn on whether a rule, service, or policy change is needed for equal housing opportunity."
  },
  {
    id: 454,
    question: "What is a discriminatory statement in advertising?",
    answer: "A statement that expresses a preference, limitation, or exclusion based on a protected characteristic.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Advertising alone can violate fair housing law even if no completed transaction occurs."
  },
  {
    id: 455,
    question: "What is a known material defect disclosure question generally asking?",
    answer: "Whether the licensee must avoid concealment and disclose a known condition that would matter to a reasonable buyer or tenant.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "National exam questions usually focus on the duty not to hide known material problems."
  },
  {
    id: 456,
    question: "What is an environmental hazard question often testing on the national exam?",
    answer: "Whether the candidate can identify a potentially material health or safety condition without assuming the licensee should act as an environmental expert.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "The exam often tests recognition and disclosure principles rather than specialized remediation advice."
  },
  {
    id: 457,
    question: "What is a closing escrow account generally used for?",
    answer: "To hold funds or documents until the conditions of the closing or settlement are satisfied.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Escrow arrangements help ensure that all parties perform before money or documents are released."
  },
  {
    id: 458,
    question: "What is a possession date issue at closing typically about?",
    answer: "Determining when the buyer gains the legal right to occupy the property under the contract or settlement terms.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Possession does not always transfer at the same moment as closing unless the agreement says so."
  },
  {
    id: 459,
    question: "What is actual authority in agency law?",
    answer: "Authority the principal intentionally gives the agent, either expressly or by implication.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "Actual authority is different from apparent authority, which arises from appearances to third parties."
  },
  {
    id: 460,
    question: "If a 3,600-square-foot building is rented at $22 per square foot per year, what is the annual rent?",
    answer: "$79,200.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Multiply the square footage by the annual rate per square foot. Here, 3,600 x $22 = $79,200."
  },
  {
    id: 461,
    question: "What is a dominant tenement?",
    answer: "The parcel of land that benefits from an easement appurtenant.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "In an easement appurtenant, the dominant tenement receives the benefit and the servient tenement bears the burden."
  },
  {
    id: 462,
    question: "What is a servient tenement?",
    answer: "The parcel of land that is burdened by an easement appurtenant.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "The servient land owner must allow the easement use, while the dominant parcel receives the benefit."
  },
  {
    id: 463,
    question: "What is an easement by implication?",
    answer: "An easement inferred from the circumstances of a prior land use when the parties did not expressly create it in writing.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Implied easements often arise when a parcel is divided and the prior use suggests continued access or utility is intended."
  },
  {
    id: 464,
    question: "What is the distinction between real rights and personal rights in property?",
    answer: "Real rights attach to the property itself, while personal rights are enforceable only against specific people.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This distinction helps explain why some interests run with the land and others do not."
  },
  {
    id: 465,
    question: "What is a corporeal interest in real estate?",
    answer: "A tangible, physical ownership interest in land or improvements.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Corporeal interests involve physical property, while incorporeal interests involve nonphysical rights such as easements."
  },
  {
    id: 466,
    question: "What is an incorporeal interest in real estate?",
    answer: "A nonphysical interest in land, such as an easement or other intangible property right.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This term appears in classic property-law questions that distinguish physical ownership from rights in land."
  },
  {
    id: 467,
    question: "What is a leasehold interest's main legal characteristic?",
    answer: "It grants the right of possession and use for a time, but not title ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Leasehold interests are nonfreehold estates because they are based on possession rather than ownership."
  },
  {
    id: 468,
    question: "What is a fee estate's main legal characteristic?",
    answer: "It is a freehold ownership estate that may be inheritable and can last indefinitely, subject to its terms.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Fee estates contrast with leasehold estates, which are based on possession for a limited term."
  },
  {
    id: 469,
    question: "What is a credit entry for the seller on a settlement statement intended to show?",
    answer: "An amount the seller is entitled to receive or be credited for in the closing accounting.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Credits increase what the seller receives or reduce what the seller owes at closing."
  },
  {
    id: 470,
    question: "What is a debit entry for the buyer on a settlement statement intended to show?",
    answer: "An amount charged to the buyer in the closing accounting.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Debits increase the buyer's cost or the cash the buyer must bring to closing."
  },
  {
    id: 471,
    question: "What is a point in mortgage lending?",
    answer: "A fee equal to 1 percent of the loan amount.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "Points are often used to express loan-origination charges or discount charges as a percentage of the loan."
  },
  {
    id: 472,
    question: "What is the distinction between discount points and origination points?",
    answer: "Discount points are generally used to adjust the lender's yield, while origination points are generally charged for making the loan.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "The exam often tests whether candidates understand that not all points serve the same purpose."
  },
  {
    id: 473,
    question: "What is the federal Fair Housing Act's disability protection generally concerned with?",
    answer: "Preventing unequal treatment and requiring equal housing opportunity for persons with disabilities under applicable law.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Disability questions often involve reasonable accommodations, reasonable modifications, and prohibited discriminatory refusals."
  },
  {
    id: 474,
    question: "What is a testing program in fair housing enforcement?",
    answer: "An investigative method using paired or otherwise structured inquiries to detect discriminatory treatment in housing transactions.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "Testing is a recognized enforcement tool because discrimination may appear only when comparable applicants are treated differently."
  },
  {
    id: 475,
    question: "What is a patent ambiguity in a contract or deed?",
    answer: "An uncertainty that is apparent on the face of the document itself.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "Patent ambiguity differs from latent ambiguity, which becomes apparent only when applying the document to external facts."
  },
  {
    id: 476,
    question: "What is a latent ambiguity in a contract or deed?",
    answer: "An uncertainty not obvious from the document alone but revealed when the language is applied to the facts.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "This concept is tested because apparently clear wording can still produce uncertainty when matched to real-world circumstances."
  },
  {
    id: 477,
    question: "What is a township tier in the rectangular survey system?",
    answer: "A row of townships running east-west and identified by how far north or south it lies from the base line.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "This is a more technical rectangular-survey term that helps candidates read full legal descriptions accurately."
  },
  {
    id: 478,
    question: "What is a range strip in the rectangular survey system?",
    answer: "A column of townships running north-south and identified by how far east or west it lies from the principal meridian.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Like township tiers, range strips help organize the survey grid into labeled rows and columns."
  },
  {
    id: 479,
    question: "What is the appraiser's effective date of value?",
    answer: "The specific date as of which the appraiser's opinion of value applies.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "An appraisal opinion is always tied to a stated date because market value can change over time."
  },
  {
    id: 480,
    question: "If a broker is entitled to a 2.5% side of the commission on a $640,000 sale, how much is that side?",
    answer: "$16,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Multiply $640,000 by 0.025 to get $16,000."
  },
  {
    id: 481,
    question: "What is an estate in reversionary possession?",
    answer: "An interest in which ownership returns to the grantor after a lesser estate ends and the grantor regains possession.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This reinforces the difference between future interests returning to the grantor and those passing to a third party."
  },
  {
    id: 482,
    question: "What is a legal estate in possession?",
    answer: "An estate in which the owner presently has the right to possess and enjoy the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This contrasts with a future interest, where possession is postponed until a later event."
  },
  {
    id: 483,
    question: "What is a tenancy in common owner's share if a deed creates co-ownership but does not specify equal shares?",
    answer: "The owners may still hold unequal shares if that is indicated by the deed or circumstances; tenancy in common does not require equal ownership interests.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This is a common exam distinction from joint tenancy, which usually requires equal interests."
  },
  {
    id: 484,
    question: "What is an appurtenant easement's main characteristic?",
    answer: "It benefits a parcel of land and generally runs with that land when ownership transfers.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "This emphasizes why an easement appurtenant is tied to the land rather than to a specific person."
  },
  {
    id: 485,
    question: "What is a personal easement's main characteristic?",
    answer: "It benefits a person or entity rather than a parcel of land and is often treated as an easement in gross.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Utility easements are common examples because the benefit belongs to the company, not an adjoining parcel."
  },
  {
    id: 486,
    question: "What is a general warranty of quiet enjoyment in a deed context?",
    answer: "A covenant that the grantee's possession will not be disturbed by someone with superior title.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "This is one of the classic deed covenants tested with warranty deeds and title assurances."
  },
  {
    id: 487,
    question: "What is a covenant of further assurance in a deed?",
    answer: "A promise that the grantor will perform future acts needed to perfect the grantee's title if necessary.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "This covenant supports the grantee if additional documents or actions are needed to clear title."
  },
  {
    id: 488,
    question: "What is a special assessment lien generally tied to?",
    answer: "A public improvement that specially benefits a particular property, such as paving, sidewalks, or sewer installation.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This differs from a general ad valorem tax because it is imposed for a specific improvement rather than general revenue."
  },
  {
    id: 489,
    question: "What is a general tax rate in property taxation used to determine?",
    answer: "The amount of tax owed based on the property's assessed value.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Tax-rate questions often appear with assessed value and mill-rate style calculations."
  },
  {
    id: 490,
    question: "What is a mill rate in property taxation?",
    answer: "A tax rate expressed in mills, where one mill equals one dollar of tax per one thousand dollars of assessed value.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Mill-rate concepts are common in national math and tax questions because they connect assessed value to tax owed."
  },
  {
    id: 491,
    question: "What is a zoning variance intended not to do?",
    answer: "It is not intended to rewrite the zoning ordinance or permanently reclassify the property.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This reinforces the distinction between a variance and rezoning."
  },
  {
    id: 492,
    question: "What is a deed restriction intended not to do?",
    answer: "It does not operate as a public zoning law; it is a private land-use restriction.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This helps distinguish private restrictions from government land-use controls."
  },
  {
    id: 493,
    question: "What is a lease's term of years intended to establish?",
    answer: "A definite period of possession with a fixed beginning and ending date.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "This restates the core feature of an estate for years in a more practical lease-drafting context."
  },
  {
    id: 494,
    question: "What is constructive notice by possession?",
    answer: "Notice a buyer may be charged with when someone is visibly occupying or using the property in a way that suggests rights may exist.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Public records are not the only source of notice; visible possession can also require further inquiry."
  },
  {
    id: 495,
    question: "What is the purpose of an estoppel certificate in leasing or title review?",
    answer: "To confirm key facts about an existing lease or occupancy situation so another party can rely on them.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Estoppel certificates are often used in sales or financing of leased property to verify lease terms and tenant claims."
  },
  {
    id: 496,
    question: "What is market data in appraisal?",
    answer: "Information from actual market transactions and conditions used to estimate value.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Comparable sales, listing trends, and market activity are examples of market data used in valuation."
  },
  {
    id: 497,
    question: "What is an arm's-length transaction?",
    answer: "A transaction between unrelated parties, each acting in their own best interest without undue pressure or special relationship.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Appraisers prefer arm's-length sales as comparables because they better reflect true market value."
  },
  {
    id: 498,
    question: "What is a disclosure requirement for known environmental contamination generally testing?",
    answer: "Whether the licensee understands the duty to disclose a known material condition without acting as an environmental expert.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "The test focus is usually on recognition and disclosure of known material hazards, not technical remediation advice."
  },
  {
    id: 499,
    question: "What is a settlement prorate for prepaid rent generally intended to do?",
    answer: "Credit the seller or landlord for rent already collected that covers time after closing, while charging the buyer for that future benefit.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Prepaid items are prorated differently from accrued items because the money was already paid before closing."
  },
  {
    id: 500,
    question: "If a property is assessed at $250,000 and the tax rate is 24 mills, what is the annual property tax?",
    answer: "$6,000.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "A 24-mill rate means $24 per $1,000 of assessed value. $250,000 / 1,000 = 250, and 250 x $24 = $6,000."
  }
];
